import { useTrackEvent } from './analytics/useTrackEvent'
import { useEventEmitter, useLocalStorageState, useThrottleEffect } from 'ahooks'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { flushSync } from 'react-dom'
import { Col, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, withRouter, useLocation } from 'react-router-dom'
import smartlookClient from 'smartlook-client'
import * as com from '../Common.js'
import * as subscriptions from '../Store/subscriptions'
import PaywallModal from '../Tools/PaywallModal/PaywallModal.js'
import './Chat.css'
import ChatHistory from './ChatHistory'
import ChatInput from './ChatInput'
import useScenarioUsed from './hooks/useScenarioUsed'
import { message, Skeleton, notification, Button } from 'antd'
import {
    CONTENT_TYPES,
    PDF_API_URL,
    PDF_CONTENT,
    PDF_GUIDELINES,
    getPdfType,
    findPdfByKeywords,
    convertS3PathToUrl,
    SCENARIO_PROGRAMS,
    PATH_CUSTOMER_ID,
    IS_IFRAMES,
    getIframesToken,
    getCheckoutStatus,
    IS_WHITE_LIST,
    IS_GUIDELINE_GPT,
    IS_MORTGAGE_GPT,
} from './constants'
import ICON_BLUERATE from './assets/bluerate.svg';
import ContinueJourney from './ContinueJourney'
import LimitReachedModal from './LimitReachedModal'
import MarkdownRenderer from './MarkdownRender'
import MessageHeader from './MessageHeader'
import MessageList from './MessageList'
import PDFViewer from './PDFViewer'
import { useAnonymousId } from './useAnonymousId'
import { isNonEmptyQuoteLocations } from './utils'
import WelcomeGuideline from './WelcomeGuideline'
import Sign from './components/Sign'
import { getClientToken, shouldRecordSmartlook } from 'utils'
import { useAllPrograms } from './hooks/useAllPrograms.ts'
import useSyncUrlPathID from './hooks/useSyncUrlPathID';
import { useContact } from './hooks/useContact'
import IframeLoginModal from './components/Widget/IframeLoginModal'
import IframeNav from './components/Widget/IframeNav'
import UserProfileModal from './components/Widget/UserProfileModal'
import SelfPayUpgradeModal from '../Common/components/Modals/SelfPayUpgradeModal'
import styles from '../Management/ApplicationSetting/index.module.css';
import store from '../Store/index'
import { request } from '../request';
import { handleAuthExpired } from '../syncStrataSession.js'
import useIframeConfig from './hooks/useIframeConfig'
import { useGetLenders } from './components/GetLenders/Banner'

// 当答案超过多少会展示 “引导注册面板”
export const LIMIT_TOKEN = 300;

function loginExpired(res){
    if (res.status === 401){
        handleAuthExpired()
        alert('Login timeout, please login again');
        if(IS_MORTGAGE_GPT()) {
            window.location.href = '/';
        } else if(IS_IFRAMES) {
            localStorage.removeItem(getIframesToken());
            window.location.href = window.location.pathname.split('/').splice(0,4).join('/');
        }else {
            window.location.href = '/guidelinegpt';
        }
    }
}

function Chat({ fromLanding, hideBackButton, anomaly, onAIChange }) {
    const { threadID, onRoutePathReplace, IS_PATH_CONFIG_ENABLED } = useSyncUrlPathID()
    const { trackUsageLimitReached, trackCheckoutStarted, trackSaspGateSignupClick, trackSaspGateSigninClick, trackStandaloneSigninClick, trackStandaloneSignupClick } = useTrackEvent()
    const chatHistoryRef = useRef(null)
    const location = useLocation()
    const [signupGuide, setSignupGuide] = useState();
    const [join, setJoin]= useState({email:'',fillIn:false}); // fillIn 快捷登陆流程不需要拿邮箱code，直接注册
    const [signType, setSignType] = useState();

    const iframeConfig = useIframeConfig();    

    // 引导注册，仅在 /guidelinegpt页，用户未登陆时出现
    const IS_LOGIN = sessionStorage.getItem("ZeitroA")
    
    // Check if current path is /askfreddie
    const isFreddieMacStandalone = location.pathname === '/askfreddie'
    const isFannieMaeStandalone = location.pathname === '/askfanniemae'

    const PDFRef = useRef()

    const [previewId, setPreviewId] = useState(); // "Scenario AI" 用户点击查看的 “guideline” pdf，若有该ID，那么一定 "Scenario AI" 的预览模式

    const [messages, setMessages] = useState([])
    const [pdCFontent, setpdCFontent] = useState('Fannie Mae')
    const [newfiMessages, setNewfiMessages] = useState([])
    const [chatThreadID, setChatThreadID] = useState('')
    const [docThreadID, setDocThreadID] = useState(threadID)
    const [newfiThreadID, setNewfiThreadID] = useState('')
    const [chatTitle, setChatTitle] = useState('')
    const [showDoc, setShowDoc] = useState(true)
    const [isBotThinking, setIsBotThinking] = useState(false)
    const [isReceivingAnswer, setIsReceivingAnswer] = useState(false) // Controls send button - only false when answer is fully complete
    const [isAnswerLoading, setIsAnswerLoading] = useState(false) // Controls loading - can be false when first reference appears
    const [isBotAnswering, setIsBotAnswering] = useState(false)
    const [isPdfLoadingFromPdf, setIsPdfLoadingFromPdf] = useState(false)
    const isPdfLoadingFromPdfRef = useRef(false)
    // isPdfLoading is now a computed value based on isAnswerLoading and isPdfLoadingFromPdf
    const isPdfLoading = useMemo(() => isAnswerLoading || isPdfLoadingFromPdf, [isAnswerLoading, isPdfLoadingFromPdf])
    const isPdfLoadingRef = useRef(false)
    const [progressMessage, setProgressMessage] = useState('')
    const [isProcessing, setIsProcessing] = useState(false)
    const [messageToSend, setMessageToSend] = useState('')
    const [currentDocName, setCurrentDocName] = useState(
        PDF_GUIDELINES.FANNIE_MAE
    )
    const [currentMessageID, setCurrentMessageID] = useState('')
    const [currentMessageText, setCurrentMessageText] = useState('')
    const [chatList, setChatList] = useState([])
    const currentRequestIdRef = useRef(null)
    const currentAbortControllerRef = useRef(null)
    
    // Store conversation states for each threadID to preserve ongoing conversations
    const conversationStatesRef = useRef(new Map())

    const [loadingChat, setLoadingChat] = useState(false)
    const [showChat, setShowChat] = useState(true)
    const [mobileAIChat, setMobileAIChat] = useState(true)
    const [dynamicPdfFile, setDynamicPdfFile] = useState(null)

    const [isMobile, setIsMobile] = useState(window.innerWidth < 576)
    const [showHistory, setShowHistory] = useState(() => {
        const bol = !isMobile && !fromLanding ? true : false;
        const cache = sessionStorage.getItem(`chat_history`);
        return ['true', 'false'].includes(cache) ? cache === 'true' : bol;
    });
    const [showIframeLoginModal, setShowIframeLoginModal] = useState(false)
    const [showUserProfileModal, setShowUserProfileModal] = useState(false)
    const [activeIframeSession, setActiveIframeSession] = useState(localStorage.getItem(getIframesToken())) // guidelinegpt 共用
    const [isIframeSignup, setIsIframeSignup] = useState(false)
    const [profile, setProfile] = useState(null)
    const [companyName, setCompanyName] = useState('')
    const [loanOfficerId, setLoanOfficerId] = useState(null)
    const [subscriptionInfo, setSubscriptionInfo] = useState({})
    const [showSelfPayUpgradeModal, setShowSelfPayUpgradeModal] = useState(false)
    const [selfPayPriceId, setSelfPayPriceId] = useState(null)
    const [selfPayPriceAmount, setSelfPayPriceAmount] = useState(0)
    const [companyPayMode, setCompanyPayMode] = useState(null)
    const [triggerType, setTriggerType] = useState('default')
    const [currentBillingStatus, setCurrentBillingStatus] = useState(null)
    const [portalSessionUrl, setPortalSessionUrl] = useState(null)
    const [trialStatus, setTrialStatus] = useState(null)
    const [applyPromoCode, setApplyPromoCode] = useState(false)
    const [promoCodeValidity, setPromoCodeValidity] = useState(null)
    const [downgradedTime, setDowngradedTime] = useState(null)

    const dispatch = useDispatch()
    const currentPdfType = useSelector((state) => state.common.content)
    const pageLoading = useSelector((state) => state.common.pageLoading)
    const showPdf = useSelector((state) => state.common.showPdf)
    const source = useSelector((state) => state.common.source)

    const IS_PAID  = profile?.AccountTier === 'paid';

    useGetLenders(isMobile, profile);

    useEffect(()=>{
        sessionStorage.setItem(`chat_history`, showHistory);
    },[showHistory]);
    
    useEffect(() => {
        const handleIframeSessionUpdated = () => {
            const sessionToken = localStorage.getItem(getIframesToken());
            if (sessionToken) {
                setActiveIframeSession(sessionToken);
            }
        };
        window.addEventListener('ZeitroIframeSessionUpdated', handleIframeSessionUpdated);
        return () => {
            window.removeEventListener('ZeitroIframeSessionUpdated', handleIframeSessionUpdated);
        };
    }, []);

    useEffect(() => {
        if (!shouldRecordSmartlook()) return
        if (IS_IFRAMES){
            smartlookClient.init('83e4fb7e995ab30cc6b912f9e25b78f099182116');
            smartlookClient.record({
                emails: true,
                forms: true,
                numbers: true,
                ips: true,
            })
            return
        } else if (sessionStorage.getItem("ZeitroA")){
            console.log("init smartlook for logged in user")
            const loId = com.getLoId()
            smartlookClient.init('702c7d241073da6ad788698d48d75342c29fa91b');
            smartlookClient.record({
                emails: true,
                forms: true,
                numbers: true,
                ips: true,
            })
            smartlookClient.identify(loId, {
                email: com.getCustomerEmail(),
            })
            return
        } else {
            console.log("init smartlook for anonymous user")
            smartlookClient.init('009412761e249d2e0b4e2e561cba901555e0a44c');
            smartlookClient.record({
                emails: true,
                forms: true,
                numbers: true,
                ips: true,
            })
            return
        }
    },[]);

    useEffect(() => {
        if(!IS_IFRAMES) getUserProfile();
        if (activeIframeSession) {
            getUserProfile();
            fetchSelfPayPrice();
            //todo
            getSubscriptionInfo();
            getCurrentBillingStatus();
            getTrialNotificationStatus();
            checkPromoCodeValidity();
        }
    }, [activeIframeSession]);

    useEffect(() => {
        if (profile && trialStatus) {
            if (trialStatus === 'pending' && profile?.AccountTier !== 'paid' && (PATH_CUSTOMER_ID === 'successlending')) {
                if (promoCodeValidity === 'valid' && currentBillingStatus === 'inactive') {
                    setTriggerType('promo-code-applied');
                    setApplyPromoCode(true);
                    setShowSelfPayUpgradeModal(true);
                } else {
                    setApplyPromoCode(false);
                }
            }
        }
    }, [profile, trialStatus, promoCodeValidity])

    useEffect(() => {
        if (IS_IFRAMES && profile && currentBillingStatus != 'inactive') {
            createPortalSession();
        }
    }, [IS_IFRAMES, currentBillingStatus, profile])

    useEffect(() => {
        if (IS_IFRAMES) {
            getClientCompanyName();
            getCompanyPayMode();
        }
    },[IS_IFRAMES])

    useEffect(() => {
       //GET query params from url
       const checkoutStatus = getCheckoutStatus();
       if (checkoutStatus === 'success') {
        message.success({
            content: 'Subscription successfully!',
            duration: 1,
            className: styles.successMessage,
        }); 
        
        // Reset to show WelcomeGuideline page after successful checkout
        dispatch({ type: 'SHOW_PDF', data: true })
        dispatch({ type: 'CHANGE_PDF', data: undefined })
        setShowDoc(false)
       } else if (checkoutStatus === 'cancel') {
        // message.error('Checkout cancelled');
        // Reset to show WelcomeGuideline page after cancelled checkout
        dispatch({ type: 'SHOW_PDF', data: true })
        dispatch({ type: 'CHANGE_PDF', data: undefined })
        setShowDoc(false)
       }
    }, [dispatch])

    useEffect(() => {
        if (profile && IS_IFRAMES) {
            smartlookClient.identify(profile.LoID, {
                email: profile.Email,
                name: profile.FirstName + ' ' + profile.LastName,
            })
        }
    },[profile])

    const checkPromoCodeValidity = async () => {
        const response = await fetch("/api/v1/los/stripe/checkPromoCodeValidity", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + activeIframeSession,
            },
            body: JSON.stringify({
                promoCodeId: ''    //leave blank will check for default self pay 1 month free promo code
            }),
        });

        if (response.ok) {
            const data = await response.json();
            setPromoCodeValidity(data.status);
        } else {
            console.error('Failed to check promo code validity', response.status);
            return;
        }
    }
    const createPortalSession = async () => {
        const response = await fetch("/api/v1/los/stripe/createPortalSession", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + activeIframeSession,
            },
            body: JSON.stringify({
                customerId: PATH_CUSTOMER_ID,
                loanOfficerID: profile?.LoID,
            }),
        });
        if (response.ok) {
            const data = await response.json();
            if (data.url) {
                setPortalSessionUrl(data.url);
            }
        } else {
            console.error('Failed to create portal session', response.status);
            return;
        }
    }

    const getDowngradedTime = async () => {
        const response = await fetch("/api/v1/los/stripe/getdowngradedtime", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + activeIframeSession,
            }
        });
        if (response.ok) {
            const data = await response.json();
            
            if (data.processedAt) {
                const date = new Date(data.processedAt);
                const month = date.toLocaleDateString('en-US', { month: 'short' });
                const day = date.getDate();
                const year = date.getFullYear();
                // Format as "Nov, 29, 2025" (with comma after month)
                const formatted = `${month} ${day}, ${year}`;
                setDowngradedTime(formatted);
            }
        } else {
            console.error('Failed to get downgraded time', response.status);
            return;
        }
    }
    const getCurrentBillingStatus = async () => {
        const response = await fetch("/api/v1/los/getCurrentBillingStatus", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + activeIframeSession,
                'Cache': 'no-cache'
            }
        })
        if (response.ok) {
            const data = await response.json();
            setCurrentBillingStatus(data.data.currentBillingStatus);
            if (data.data.currentBillingStatus !== 'inactive' && data.data.currentBillingStatus !== 'active') {
                getDowngradedTime();
            }
            if (data.data.currentBillingStatus === 'past_due') {
                setTriggerType('past-due');
                setShowSelfPayUpgradeModal(true);
            }
        } else {
            console.error('Failed to get current billing status', response.status);
            return;
        }
    }

    const getTrialNotificationStatus = async () => {
        const response = await fetch("/api/v1/los/getTrialNotificationStatus", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + activeIframeSession,
                'Cache': 'no-cache'
            } 
        });
        if (response.ok) {
            const data = await response.json();
            setTrialStatus(data.data.trialNotificationStatus);
           
        } else {
            console.error('Failed to get trial notification status', response.status);
            return;
        }
    }

    const updateTrialNotificationStatus = async () => {
        const response = await fetch("/api/v1/los/updateTrialNotificationStatus", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + activeIframeSession,
                'Cache': 'no-cache'
            }
        });
        if (response.ok) {
            const data = await response.json();
            if (data.data !== 'OK') {
                console.error('Failed to update trial notification status', data.message);
                return;
            } else {
                setTriggerType('default');
                setShowSelfPayUpgradeModal(false);
            }
        } else {
            console.error('Failed to update trial notification status', response.status);
            return;
        }
    }

    const getCurrentScenarioUsage = () => {
        const MAX_COUNT = 3;
        const currentState = store.getState();
        const currentStore = currentState?.subscriptionReducer?.currentInfo || {};

        const scenarioDeskUsage = currentStore?.usage?.scenarioDeskUsage || 0;
        const guidelineGptUsage = currentStore?.usage?.guidelineGptUsage || 0;
        
        // Get current count (same logic as useScenarioUsed hook)
        const isLoggedIn = !!sessionStorage.getItem("ZeitroA") || !!localStorage.getItem(getIframesToken());
        let currentCount;
        
        if (isLoggedIn) {
            
            // In iframe mode, combine guideline and scenario desk usage
            if (IS_IFRAMES) {
                currentCount = scenarioDeskUsage + guidelineGptUsage;
            } else {
                currentCount = scenarioDeskUsage;
            }
        } else {
            // 未登录用户从localStorage读取
            const scenarioCount = scenarioDeskUsage ? parseInt(scenarioDeskUsage, 10) : 0;
            
            // In iframe mode, also read guideline usage from localStorage
            if (IS_IFRAMES) {
                // const localGuidelineCount = localStorage.getItem("guideline");
                const guidelineCount = guidelineGptUsage ? parseInt(guidelineGptUsage, 10) : 0;
                currentCount = scenarioCount + guidelineCount;
            } else {
                currentCount = scenarioCount;
            }
        }
        
        // Compute values (same logic as useScenarioUsed hook)
        const shouldApplyLimit = !IS_WHITE_LIST;
        const FREE_STATUS = com.getFreeStatus(currentStore?.plan, currentStore?.loanOfficers);
        const REMAINING_COUNT = MAX_COUNT - currentCount;
        
        return {
            COUNT: currentCount,
            DISABLED: shouldApplyLimit && currentCount > MAX_COUNT - 1,
            REMAINING: REMAINING_COUNT > 0 ? REMAINING_COUNT : 0,
            PAID: !FREE_STATUS,
        };
    }

   const getCompanyPayMode = async () => {
        try {
            const response = await fetch("/api/v1/los/getCompanyPayMode?customerid=" + PATH_CUSTOMER_ID, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + activeIframeSession,
                }
            });
            if (response.ok) {
                const data = await response.json();
                setCompanyPayMode(data.data.paymentMode);
            } else {
                message.error('Failed to get company pay mode');
            }
        } catch (error) {
                console.error('Error getting company pay mode:', error);
        }
    }

    const fetchSelfPayPrice = async () => {
        try {
          // const response = await fetch("/los/stripe/config");
          const response = await fetch("/api/v1/los/stripe/config");
          if (response.ok) {
            // const { prices } = await response.json();
            const { prices } = await response.json();
            let selfPayPrice = prices.find(p => p.metadata?.displayed_name?.toLowerCase() === 'self_pay');
            if (PATH_CUSTOMER_ID === 'nationwide') {
                selfPayPrice = prices.find(p => p.metadata?.displayed_name?.toLowerCase() === 'self_pay_nationwide');
            }
            setSelfPayPriceId(selfPayPrice.id);
            setSelfPayPriceAmount(selfPayPrice.unit_amount / 100);
          } else {
            console.error("Failed to fetch prices");
            message.error("Failed to load pricing information. Please try again.");
          }
        } catch (error) {
          console.error("Error fetching prices:", error);
          message.error("Failed to load pricing information. Please try again.");
        }
    };

    const getUserProfile = () => {
        return new Promise((resolve) => {
            const token = IS_IFRAMES? activeIframeSession : window.sessionStorage.getItem("ZeitroA");
            fetch('/los/getprofile', {
                method: 'GET',
                cache: 'no-cache',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Cache': 'no-cache'
                }
            }).then( (response) => {
                if (!response.ok) {
                    message.error('Failed to get user profile, session token invalid');
                    IS_IFRAMES && localStorage.removeItem(getIframesToken());
                    return;
                } else {
                    response.json().then( (js) => {
                        if (js.Status !== 'OK') {
                            if(IS_IFRAMES) {
                                message.error('Session authentication failed, please sign in again');
                                localStorage.removeItem(getIframesToken());
                                setTimeout(() => {
                                    window.location.reload();
                                }, 1000);
                            }
                        } else {
                            let loan = js.LoanOfficers[0]
                            const params = {
                                ID: loan.ID,
                                LoID: loan.ID,
                                UserRoles: loan.Roles,
                                Phone: loan.Phone,
                                Image: loan.Image,
                                LicenseID: loan.LicenseID,
                                Introduction: loan.Introduction,
                                FirstName: loan.FirstName,
                                LastName: loan.LastName,
                                Email: loan.Email,
                                NMLSID: loan.Nmls,
                                OrganizationName: loan.BranchName,
                                AccountTier: loan.AccountTier,
                                CreatedAt: loan.CreatedAt,
                                Role: loan.Roles[0],
                            }
                            setLoanOfficerId(loan.ID);
                            setProfile(params);
                            resolve(params);
                        }
                    });
                }
            });
        })
    }

    // function onBluerateStart(){
    //     const token = localStorage.getItem(getIframesToken());
    //     localStorage.removeItem(getIframesToken());
    //     sessionStorage.setItem('ZeitroA',token);
    //     window.location.href = `${window.location.origin}/app/landingpage`;
    // }

    // const IS_LOAN_OFFICER = profile?.UserRoles?.includes?.("LoanOfficer");

    // useEffect(() => {
    //     showPdf && !isMobile && IS_GUIDELINE_GPT && IS_LOAN_OFFICER && notification.info({
    //         duration: 0,
    //         placement: 'bottomRight',
    //         key: "notif-bluerate",
    //         className:'hint-notif hint-notif-bluerate',
    //         message: <img src={ICON_BLUERATE} />,
    //         description: <div className='hint-notif-ctx hint-bluerate-ctx'>
    //             <p>Your Bluerate profile is ready!</p>
    //             <p>Complete your setup to get listed on the marketplace and start attracting leads.</p>
    //             <Button onClick={onBluerateStart} type='primary'>Get started</Button>
    //         </div>,
    //     });
    // }, [IS_LOAN_OFFICER]);

    // useEffect(()=>{
    //     showPdf || notification.destroy("notif-bluerate");
    // },[showPdf]);

    const getStripeCheckOut = useCallback(async () => {
        const token = IS_IFRAMES ? activeIframeSession : sessionStorage.getItem("ZeitroA");
        const res = await fetch("/api/v1/los/stripe/createCheckoutSession", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
            Cache: "no-cache",
          },
          body: JSON.stringify({
            loanOfficerID: IS_IFRAMES ? profile.LoID : com.getLoId(),
            email: IS_IFRAMES ? profile.Email : com.getCustomerEmail(),
            customerID: IS_IFRAMES ? PATH_CUSTOMER_ID : com.getCustomerId(),
            PriceID: selfPayPriceId,
            ApplyPromoCode: applyPromoCode,
            LimitUsage: getCurrentScenarioUsage().COUNT,
            TriggerType: triggerType,
            UserRole: profile?.Role,
          }),
        }).then(res => {
        if (!res.ok){
            loginExpired(res)
            throw new Error(`HTTP error! status: ${res.status}`);
        }
          return res.json(); // 或 .text()
        })
        .then(data => {
          console.log('成功解析:', data);
          console.log(`res: `, data)
          if (data?.url) {
            window.location.href = data?.url;
          }
        });
    }, [IS_IFRAMES, activeIframeSession, profile, selfPayPriceId, applyPromoCode, triggerType, trackCheckoutStarted, getCurrentScenarioUsage, currentBillingStatus])

    const getSubscriptionInfo = async () => {
        const response = await fetch("/los/getcurrentsubscription", {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + (IS_IFRAMES ? activeIframeSession : sessionStorage.getItem('ZeitroA')),
                'Cache': 'no-cache',
                'X-Mode': IS_IFRAMES ? 'IS_IFRAME' : undefined,
            }
        });
        loginExpired(response)
        const DataInfo = await response.json();
        dispatch({ type: "SUBSCRIPTION_INFO", data: {...DataInfo, loading: true} });
    }

    const handleCheckOut = () => {
        getStripeCheckOut();
    }

    const handleCloseUpgradeModal = () => {
        if (triggerType === 'promo-code-applied') {
            // updateTrialNotificationStatus();
            setApplyPromoCode(false);
            setTriggerType('default');
            setShowSelfPayUpgradeModal(false);
        } else {
            setTriggerType('default');
            setShowSelfPayUpgradeModal(false);
        }
    }
    
    const getClientCompanyName = () => {
        fetch('/los/iframe/getcompanynamebyid', {
            method: 'GET',
            cache: 'no-cache',
            headers: {
                'Cache': 'no-cache',
                'X-CustomerID': PATH_CUSTOMER_ID,
            }
        }).then( (response) => {
            if (response.status === 404) {
                window.location.href = '/error/404';
                return;
            }
            if (!response.ok) {
                message.error('Failed to get company name, customerid invalid');
                return;
            } else {
                response.json().then( (js) => {
                    if (js.status !== 'OK') {
                    } else {
                        setCompanyName(js.companyName);
                    }
                });
            }
        });
    }

    // Monitor scenario model changes and reset states when switching between Instant/DeepSearch
    // useEffect(() => {
    //     const handleStorageChange = () => {
    //         setIsProcessing(false)
    //         setProgressMessage('')
    //         currentRequestIdRef.current = null
    //     }

    //     // Listen for scenario model changes
    //     window.addEventListener('scenarioModelChange', handleStorageChange)

    //     return () => {
    //         window.removeEventListener('scenarioModelChange', handleStorageChange)
    //     }
    // }, [])
    const programs = useAllPrograms(activeIframeSession)

    const subscriptionReducer = useSelector(
        (state) => state.subscriptionReducer?.currentInfo
    )
    const gptUsage =
        useSelector(
            (state) =>
                state.subscriptionReducer?.currentInfo?.usage?.guidelineGptUsage
        ) || 0
    const SCENARIO_AI_USE = useScenarioUsed();
    const jumpEmitter = useEventEmitter()
    const mountEmitter = useEventEmitter()
    const titleEmitter = useEventEmitter()

    const [questionCount, setQuestionCount] = useLocalStorageState(
        'gptQuestionCount',
        {
            defaultValue: 0,
            listenStorageChange: true,
        }
    )
    const [showLimitModal, setShowLimitModal] = useState(false)

    const jumpParams = useRef(null)

    const [showPaywallModal, setShowPaywallModal] = useState(false)
    const [isLandingWelcome, setIsLandingWelcome] = useState(false)
    const [showContinueJourney, setShowContinueJourney] = useState(false)

    // Add journey submitted state to be managed in Chat component
    const [journeySubmitted, setJourneySubmitted] = useState(false)

    const openHistory = useMemo(() => {
        return showHistory && !fromLanding
    }, [showHistory, fromLanding])

    // Get anonymous ID for anonymous users
    const anonymousId = useAnonymousId()

    // Listen to chat title update event
    titleEmitter.useSubscription((data) => {
        if (data.threadId === docThreadID) {
            setChatTitle(data.newTitle)
        }
    })

    const getFreeStatus = () => {
        return com.getFreeStatus(
            subscriptionReducer.plan,
            subscriptionReducer.loanOfficers
        )
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 576)
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        if (getFreeStatus() && gptUsage === 5) {
            setIsLandingWelcome(true)
        }
    }, [gptUsage])

    // Fetch trial usage count from API
    const fetchTrialUsage = useCallback(async () => {
        if (!fromLanding || !anonymousId) return

        try {
            const response = await fetch(
                `/los/mortgagegpt/trialusage?loID=${encodeURIComponent(
                    anonymousId
                )}`
            )
            if (response.ok) {
                const data = await response.json()
                return data
            } else {
                console.error('Failed to fetch trial usage:', response.status)
            }
        } catch (error) {
            console.error('Error fetching trial usage:', error)
            // Fallback to current count on error
        }
    }, [fromLanding, anonymousId])

    // Initialize question count on component mount
    useEffect(() => {
        if (fromLanding && !isFreddieMacStandalone && !isFannieMaeStandalone) {
            fetchTrialUsage().then((data) => {
                const count = data.trialCount || 0
                setQuestionCount(count)
            })
        }
    }, [fetchTrialUsage, isFreddieMacStandalone, isFannieMaeStandalone])

    const getContinueJourney = useCallback(async () => {
        try {
            const response = await fetch(
                `/los/mortgagegpt/continuejourney?loID=${encodeURIComponent(
                    anonymousId
                )}`
            )
            if (response.ok) {
                const statusData = await response.json()
                return statusData.hasSubmitted || false
            } else {
                console.error(
                    'Failed to fetch continue journey:',
                    response.status
                )
            }
        } catch (error) {
            console.error('Error checking continue journey:', error)
        }
    }, [anonymousId])

    // Initialize journey submitted status
    useEffect(() => {
        const initJourneyStatus = async () => {
            if (fromLanding && anonymousId && !isFreddieMacStandalone && !isFannieMaeStandalone) {
                const hasSubmitted = await getContinueJourney()
                setJourneySubmitted(hasSubmitted)
            }
        }

        initJourneyStatus()
    }, [fromLanding, anonymousId, getContinueJourney, isFreddieMacStandalone, isFannieMaeStandalone])

    // Check and update question count using API
    const checkQuestionLimit = useCallback(async () => {
        if (!fromLanding || isFreddieMacStandalone || isFannieMaeStandalone || IS_IFRAMES) return true

        try {
            const data = await fetchTrialUsage()
            const trialCount = Math.max(data.trialCount, questionCount)

            // check if anonymous user has submitted Continue Journey form via API
            const hasSubmitted = await getContinueJourney()
            setJourneySubmitted(hasSubmitted)

            // already used once that day, and not submitted the continue journey form
            if (trialCount === 1 && !hasSubmitted) {
                setShowContinueJourney(true)
                return false
            }

            // the free 5 times of the day have been used up
            if (trialCount >= 5) {
                setShowLimitModal(true)
                return false
            }

            // increment the question count and allow the question
            setQuestionCount(trialCount + 1)
            return true
        } catch (error) {
            console.error('Error checking question limit:', error)
            return false
        }
    }, [
        fromLanding,
        anonymousId,
        fetchTrialUsage,
        currentPdfType,
        docThreadID,
        getContinueJourney,
        questionCount,
        isFreddieMacStandalone,
        isFannieMaeStandalone,
    ])

    useEffect(() => {
        // dispatch(subscriptions.updateGuidelineUsage(0))
        if (currentPdfType && 
            currentPdfType !== CONTENT_TYPES.SCENARIO_GMCC && 
            currentPdfType !== CONTENT_TYPES.SCENARIO_DESK) {
            // When switching to Agency guidelines mode, always reset states
            // Clear request tracking to prevent ongoing requests from updating messages
            // The request ID check in questionStreaming will ignore updates from old requests
            currentRequestIdRef.current = null
            
            // Always reset messages and states when switching to guideline mode to ensure clean state
            // This also applies when switching between different guideline PDFs
            // Note: We reset regardless of loading state to prevent messages from other modes appearing
            setDocMessages([{ text: 'type-greeting', sender: 'bot' }])
            setIsReceivingAnswer(false)
            setIsAnswerLoading(false)
            setIsBotThinking(false)
            setIsBotAnswering(false)
            setIsProcessing(false)
            setProgressMessage('')
            setCurrentMessageID('')
            setCurrentMessageText('')
            isPdfLoadingRef.current = false
            isPdfLoadingFromPdfRef.current = false
            setIsPdfLoadingFromPdf(false)
            setChatTitle('')
            setDocThreadID('')
            setNewfiThreadID('')
            setChatThreadID('')
        }
        
        // Clear dynamic PDF when switching away from scenario desk
        if (currentPdfType !== CONTENT_TYPES.SCENARIO_DESK) {
            setDynamicPdfFile(null)
        }
    }, [currentPdfType])

    mountEmitter.useSubscription(() => {
        // if mobile and jumpParams is not null, emit the jump event
        if (isMobile && jumpParams.current) {
            jumpEmitter.emit(jumpParams.current)
            jumpParams.current = null
        }
    })

    const jumpToPage = async (pageNumber, locations = [], index, dynamicPdfInfo = null) => {
        // Handle dynamic PDF loading for new scenario desk
        if (dynamicPdfInfo && dynamicPdfInfo.dynamicLoad) {
            const pdfFileName = dynamicPdfInfo.pdfFileName
            // Use keyword-based matching instead of exact filename matching
            let pdfPath = await findPdfByKeywords(pdfFileName)
            
            // If no match found, log for debugging
            if (!pdfPath) {
                console.warn('PDF mapping not found for:', pdfFileName)
                console.log('Consider updating keyword mappings in findPdfByKeywords function')
            }

            if (pdfPath) {
                let absolutePdfPath;
                // Check if it's already an absolute URL (S3 URL)
                if (pdfPath.startsWith('http')) {
                    absolutePdfPath = pdfPath;
                } else {
                    // Encode the path to handle special characters
                    const encodedPath = pdfPath.split('/').map(part => part === '' ? '' : encodeURIComponent(part)).join('/')
                    // Convert to absolute URL for server requests
                    absolutePdfPath = `${window.location.origin}${encodedPath}`;
                }
                // Set the dynamic PDF file for the viewer
                setDynamicPdfFile(absolutePdfPath)
                
                if (isMobile) {
                    jumpParams.current = {
                        pageNumber: parseInt(pageNumber) || 1,
                        pageCoordinates: [],
                        dynamicPdf: absolutePdfPath,
                    }
                    setMobileAIChat(false)
                } else {
                    jumpEmitter.emit({
                        pageNumber: parseInt(pageNumber) || 1,
                        pageCoordinates: [],
                        dynamicPdf: absolutePdfPath,
                    })
                }
                return
            }

            if (CONTENT_TYPES.SCENARIO_GMCC) {
                if (pdfFileName.includes('Agate')) {
                    pageNumber += 10
                } else if (pdfFileName.includes('Mercury')) {
                    pageNumber += 237
                } else if (pdfFileName.includes('Onyx')) {
                    pageNumber += 282
                }
            }
        }

        // Original logic for static PDFs
        if (index >= 0 && index < locations.length) {
            // Find matching page coordinates
            const pageCoordinates = locations[index]

            if (isMobile) {
                // Store the jump parameters for later use
                jumpParams.current = {
                    pageNumber: parseInt(pageNumber) || 1,
                    pageCoordinates: pageCoordinates ? pageCoordinates[1] : [],
                }
                setMobileAIChat(false)
            } else {
                // For desktop, emit event immediately
                jumpEmitter.emit({
                    pageNumber: parseInt(pageNumber) || 1,
                    pageCoordinates: pageCoordinates ? pageCoordinates[1] : [],
                })
            }
        }
    }

    /**
     * Formulate bot answer
     */
    const formulateAnswer = useCallback(
        (
            answer,
            pageNumber,
            quoteLocations,
            isGenerating = false,
        ) => {
            let text = (
                <MarkdownRenderer
                    answer={answer}
                    isMobile={isMobile}
                    pageNumber={pageNumber}
                    quoteLocations={quoteLocations}
                    isGenerating={isGenerating}
                    referenceFunc={async (pageNumber, locations, index, dynamicPdfInfo) => {
                        if(PDFRef.current && PDFRef.current.handleSourceChange && dynamicPdfInfo){
                            // Use Promise to wait for PDF loading completion
                            PDFRef.current.handleSourceChange(dynamicPdfInfo.pdfFileName)
                            await PDFRef.current.getLoadStatus();
                        }
                        await jumpToPage(pageNumber, locations, index, dynamicPdfInfo)
                    }
                    }
                />
            )

            if (isNonEmptyQuoteLocations(quoteLocations)) {
                text = <div>{text}</div>
            }

            return text
        },
        [jumpToPage]
    )

    const getTextToCopy = (answer, quoteLocations) => {
        // Remove last line if it contains 'Referenced context'
        let textToCopy = answer.replace(
            /^Referenced context:\s*\[[^\]]+\]\s*$/gm,
            ''
        )
        // Remove invalid reference links and map to actual page numbers
        textToCopy = textToCopy.replace(
            /\[([1-9]\d*(?:\s*,\s*[1-9]\d*)*)\]/g,
            (match, numbers) => {
                // Only filter refs if we have valid locations
                if (isNonEmptyQuoteLocations(quoteLocations)) {
                    const sortedPages = Array.from(
                        new Set(quoteLocations.map(([page]) => page))
                    ).sort((a, b) => a - b)
                    const refs = numbers
                        .split(',')
                        .map((n) => parseInt(n.trim()))

                    // Map reference to actual page numbers
                    const pageNumbers = refs
                        .map((ref) => {
                            const index = ref - 1 // Convert reference to array index
                            return index >= 0 && index < sortedPages.length
                                ? sortedPages[index]
                                : null
                        })
                        .filter((page) => page !== null)

                    return pageNumbers.length > 0
                        ? `[${pageNumbers.join(',')}]`
                        : ''
                }

                // If no valid locations, keep original reference
                return match
            }
        )
        return textToCopy
    }

    /**
     * Tracking and logging for doc messages
     * @param {string} message - The sent message
     * @param {string} threadID - The thread ID
     */
    const TrackingDocMessage = (_message, _threadID) => {
        // no-op: Statsig event tracking removed
    }

    const initLoggedIn = useRef(Boolean(sessionStorage.getItem('ZeitroA')))

    useEffect(() => {
        if (!initLoggedIn.current && docThreadID && IS_LOGIN) {
            request("/api/v1/mortgagegpt/sessionRelate", {
                method: "POST",
                body: { threadId: docThreadID },
            }).then(() => {
                initLoggedIn.current = true;
            });
        }
    }, [docThreadID, IS_LOGIN]);

    /**
     * Processing logic for both doc and scenario messages
     * Focuses only on sending message and handling stream response
     * @param {string} message - The message to send
     * @param {string} pdfType - PDF type
     * @param {string} docName - Document name (for doc messages)
     * @param {string} guidelines - Guidelines (for scenario messages)
     */
    const questionStreaming = async (message, pdfType, docName, guidelines) => {
        const isScenario = pdfType === CONTENT_TYPES.SCENARIO_GMCC || pdfType === CONTENT_TYPES.SCENARIO_DESK
        
        // Set receiving answer state IMMEDIATELY at the start, before any other operations
        // This ensures loading is visible even when navigating from homepage
        // isPdfLoading will be automatically computed as true because isReceivingAnswer is true
        isPdfLoadingRef.current = true
        
        setDocMessages((prevMessages) => {
            if (isScenario) {
                // For scenario mode, check if we're starting a new conversation
                // This happens when:
                // 1. There's only one bot greeting message
                // 2. The user is coming from the welcome screen (showPdf was true)
                const hasOnlyGreeting = prevMessages.length === 1 && 
                    prevMessages[0].sender === 'bot' && 
                    (prevMessages[0].text === 'reset-greeting' || 
                     prevMessages[0].text === 'type-greeting')
                
                if (hasOnlyGreeting) {
                    return [{ text: message, sender: 'user' }]
                }
            }
            return [...prevMessages, { text: message, sender: 'user' }]
        })

        setIsBotThinking(true)
        setIsBotAnswering(false)
        setCurrentMessageID('')
        setProgressMessage('')
        setIsProcessing(false)

        let urlPathId = threadID;
        let lastMessageData = null
        let isFirstMessage = true
        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
        
        // Generate a unique request ID to track this request
        // Use threadID if available (for existing chats), otherwise use timestamp + random (for new chats)
        const requestId = docThreadID || (Date.now() + Math.random())
        currentRequestIdRef.current = requestId

        // Create AbortController for this request
        const abortController = new AbortController()
        currentAbortControllerRef.current = abortController

        setIsReceivingAnswer(true) // Disable send button
        setIsAnswerLoading(true) // Show loading
        // isPdfLoading will be automatically computed as true because isAnswerLoading is true
        isPdfLoadingRef.current = true // Update ref for closure access

        try {
            const token =  IS_IFRAMES ? localStorage.getItem(getIframesToken()) : sessionStorage.getItem('ZeitroA')
            let customerId = com.getCustomerId()
            const getCompanyName = () => {
                if(customerId === "greenbox" || PATH_CUSTOMER_ID === "greenbox") return "Greenbox"
                if(customerId?.includes("newwave") || PATH_CUSTOMER_ID?.includes("newwave")) return "NewWave"
                if(customerId === "nationdirect" || PATH_CUSTOMER_ID === "nationdirect") return "NationDirect"
                if(customerId === "nationsdirect" || PATH_CUSTOMER_ID === "nationsdirect") return "NationDirect"
                if(customerId === "calhfa" || PATH_CUSTOMER_ID === "calhfa") return "CalHFA"
                if(customerId === "megacapital" || PATH_CUSTOMER_ID === "megacapital") return "MegaCapital"
                return "Mortgage"
            }

            const LoID = IS_GUIDELINE_GPT ? profile?.LoID : IS_IFRAMES ? loanOfficerId : fromLanding ? anonymousId : com.getLoId();
            
            const response = await fetch(PDF_API_URL[pdfType], {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                    Cache: 'no-cache',
                },
                body: JSON.stringify({
                    Message: message,
                    ThreadID: IS_IFRAMES ? "" : docThreadID,
                    Doc: pdfType,
                    FromLanding: !LoID, // 只要登录了就需要记录这次提问history
                    LoID,
                    Documents: previewId ? programs.data.GUIDELINES_ID : guidelines,
                    Mode: "deepthinking", // 现在全部调整为 “深度思考”
                    // Mode: sessionStorage.getItem("scenario_model") || "instant",
                    CompanyName: getCompanyName(),
                    UseOverlay: (customerId?.includes("newwave") || PATH_CUSTOMER_ID?.includes("newwave") || customerId === "nationdirect" || customerId === "nationsdirect" || PATH_CUSTOMER_ID === "nationdirect" || PATH_CUSTOMER_ID === "nationsdirect" ) ? true : false,
                }),
                signal: abortController.signal
            })

            if (!response.ok) {
                loginExpired(response)
                throw new Error(`HTTP error! Status: ${response.status}`)
            }

            const reader = response.body.getReader()
            const decoder = new TextDecoder()
            let buffer = ''

            let thinking = [] // 思考内容可能会有多次，需要增量保存
            let status; // 状态
            const thinkingStartDate = Date.now(); // 思考开始时间
            let thinkingEndDate; // 思考结束时间

            let used = false; // 一个回答，只能记录一次
            const processBuffer = async () => {
                // Track usage
                // 后端会在 "scenariodesk" API  生成 答案的 EventStream后，才会记录
                // Only count usage if request hasn't been aborted
                if (isScenario && !used && !abortController.signal.aborted) {
                    used = true;
                    SCENARIO_AI_USE.onUsed()

                }
                // Process all complete lines in the buffer
                while (buffer.includes('\n')) {
                    const newlineIndex = buffer.indexOf('\n')
                    let line = buffer.slice(0, newlineIndex).trim()
                    buffer = buffer.slice(newlineIndex + 1)
                    
                    // Skip empty lines
                    if (!line) {
                        continue
                    }
                    
                    // Handle both old format (data: ) and new format (direct JSON)
                    let data = null
                    try {
                        if (line.startsWith('data: ')) {
                            const jsonStr = line.slice(6).trim()
                            if (jsonStr) {
                                data = JSON.parse(jsonStr)
                            }
                        } else {
                            // Try to parse as direct JSON
                            data = JSON.parse(line)
                        }
                    } catch (e) {
                        // Log the error for debugging but continue processing
                        console.warn('Failed to parse JSON line:', line, 'Error:', e.message)
                        
                        // If it's a JSON parsing error, try to extract partial data
                        if (e.name === 'SyntaxError' && line.includes('{')) {
                            try {
                                // Try to find and parse partial JSON objects
                                const jsonMatch = line.match(/\{.*\}/)
                                if (jsonMatch) {
                                    const partialJson = jsonMatch[0]
                                    data = JSON.parse(partialJson)
                                    console.log('Successfully parsed partial JSON:', data)
                                }
                            } catch (partialError) {
                                console.warn('Failed to parse partial JSON:', partialError.message)
                            }
                        }
                        
                        if (!data) {
                            continue
                        }
                    }

                    const message = data.message || data.content

                    if (data) {
                        // debugger
                        // Handle new status messages from updated backend
                        if (data.status && message && ['processing', 'retrieving', 'analyzing', 'thinking'].includes(data.status)) {
                            // Check if this request is still valid before setting progress message
                            if (currentRequestIdRef.current === requestId) {
                                setProgressMessage(message)
                                setIsProcessing(true)
                            }

                            // 思考
                            if(data.status === 'thinking') {
                                if(status !== 'thinking'){
                                    thinking.push(message);
                                }
                                const index = thinking.length - 1;
                                thinking[index] = message
                                // DeepSearch 深度思考，只需要把最新的思考内容插到消息题内部就行, 用thinking字段
                                setDocMessages((messages) => {
                                    // Check if this request is still valid
                                    if (currentRequestIdRef.current !== requestId) {
                                        return messages; // Ignore updates from cancelled requests
                                    }
                                    const last = messages.at(-1);
                                    if (last?.sender === "bot") {
                                        last.thinking = thinking;
                                        last.thinkingStartDate = thinkingStartDate;
                                    }
                                    return [...messages];
                                });
                            } else if (isScenario && ['processing', 'retrieving', 'analyzing'].includes(data.status)) {
                            // Show progress message in chat for scenario desk
                                setDocMessages((prevMessages) => {
                                    // Check if this request is still valid
                                    if (currentRequestIdRef.current !== requestId) {
                                        return prevMessages; // Ignore updates from cancelled requests
                                    }
                                    const newMessages = [...prevMessages]
                                    // Remove any existing progress message
                                    const filteredMessages = newMessages.filter(msg => 
                                        !(msg.sender === 'bot' && msg.isProgress))

                                    // Add new progress message
                                    return [...filteredMessages, { 
                                        text: message, 
                                        sender: 'bot',
                                        isProgress: true,
                                        thinkingStartDate,
                                        thinkingEndDate,
                                        thinking
                                    }]
                                })
                            }
                            status = data.status
                            continue
                        }
                        
                        // Handle error messages
                        if (data.error) {
                            setIsBotAnswering(true)
                            setDocMessages((prevMessages) => {
                                // Check if this request is still valid
                                if (currentRequestIdRef.current !== requestId) {
                                    return prevMessages; // Ignore updates from cancelled requests
                                }
                                return [
                                    ...prevMessages,
                                    { text: `❌ Error: ${data.error}`, sender: 'bot' },
                                ]
                            })
                            setIsBotThinking(false)
                            setIsProcessing(false)
                            return
                        }
                        
                        // Handle old format with RunID
                        if (data.RunID === 'Not Mortgage') {
                            setIsBotAnswering(true)
                            setDocMessages((prevMessages) => {
                                // Check if this request is still valid
                                if (currentRequestIdRef.current !== requestId) {
                                    return prevMessages; // Ignore updates from cancelled requests
                                }
                                return [
                                    ...prevMessages,
                                    { text: data.Answer, sender: 'bot' },
                                ]
                            })
                            setIsBotThinking(false)
                            setIsProcessing(false)
                            return
                        }

                        // Handle regular message data (Answer, PageNumber, QuoteLocations, etc.)
                        if (data.Answer !== undefined || data.status === 'finished') {
                            
                            if(data.ThreadID && urlPathId !== data.ThreadID){
                                urlPathId = data.ThreadID
                                onRoutePathReplace(urlPathId);
                            }

                            if(!thinkingEndDate){
                                thinkingEndDate = Date.now();
                            }

                            if(data?.ThreadID){
                                lastMessageData = data
                            }
                            
                            const isStillGenerating = data.status === 'finished'
                            const currentAnswer = formulateAnswer(
                                data.Answer || data.content,
                                data.PageNumber,
                                data.QuoteLocations,
                                isStillGenerating, // Still generating when status is 'finished'
                            )
                            
                            // Check if first reference page appears in answer text AFTER processing answer
                            // For scenariodesk API, we only need to check if answer contains reference links
                            // Support multiple formats: [1], [1,2], [p.1], ["doc", p.1], etc.
                            const answerText = data.Answer || data.content || ''
                            
                            // Check for various reference formats
                            // Only stop loading for Scenario AI mode, not for Agency guidelines mode
                            if (isScenario) {
                                const hasReferenceInText = /\[[1-9]\d*(?:\s*,\s*[1-9]\d*)*\]/.test(answerText) || 
                                                          /\[p\.\s*\d+/.test(answerText) ||
                                                          /\[.*p\.\s*\d+/.test(answerText)
                                
                                // Stop loading when first reference link appears in answer text (Scenario AI only)
                                // Note: Only stop loading (isAnswerLoading), but keep isReceivingAnswer true to prevent send button from becoming active
                                if (isPdfLoadingRef.current && hasReferenceInText) {
                                    // Update ref first to prevent multiple triggers
                                    isPdfLoadingRef.current = false
                                    // Stop loading state, but keep isReceivingAnswer true (for send button)
                                    // isPdfLoading will be automatically computed
                                    // If PDF is still loading, isPdfLoading will remain true; otherwise it will be false
                                    flushSync(() => {
                                        setIsAnswerLoading(false) // Stop loading when first reference appears
                                        // Don't set isReceivingAnswer to false here - answer is still streaming
                                    })
                                    requestAnimationFrame(() => {
                                        setIsAnswerLoading(false)
                                    })
                                }
                            }

                            setCurrentMessageText(
                                getTextToCopy(data.Answer || message, data.QuoteLocations)
                            )

                            await delay(50)

                            setIsBotAnswering(true)
                            setIsProcessing(false)
                            setProgressMessage('')

                            setDocMessages((prevMessages) => {
                                // Check if this request is still valid
                                if (currentRequestIdRef.current !== requestId) {
                                    return prevMessages; // Ignore updates from cancelled requests
                                }
                                
                                // Remove progress messages before adding the actual answer
                                const filteredMessages = prevMessages.filter(msg => 
                                    !(msg.sender === 'bot' && msg.isProgress))
                                
                                if (isFirstMessage) {
                                    isFirstMessage = false
                                    return [
                                        ...filteredMessages,
                                        { text: currentAnswer, sender: 'bot', thinkingStartDate, thinkingEndDate, thinking, lenderIds: data?.LenderIDs },
                                    ]
                                } else {
                                    const newMessages = [...filteredMessages]
                                    newMessages[newMessages.length - 1] = {
                                        text: currentAnswer,
                                        sender: 'bot',
                                        thinkingStartDate,
                                        thinkingEndDate,
                                        thinking,
                                        lenderIds: data?.LenderIDs
                                    }
                                    return newMessages
                                }
                            })
                            setIsBotThinking(false)
                        }

                        status = data.status

                    }
                }
            }
        
            while (true) {
                const { done, value } = await reader.read()
                if (done) break

                // Append new data to the buffer
                const chunk = decoder.decode(value, { stream: true })
                buffer += chunk
                
                // Debug logging for troubleshooting
                if (chunk.length > 0) {
                    console.log('Received chunk:', chunk.substring(0, 100) + (chunk.length > 100 ? '...' : ''))
                }
                
                await processBuffer()
            }

            // Process any remaining data in the buffer
            if (buffer.length > 0) {
                console.log('Processing remaining buffer:', buffer.substring(0, 100) + (buffer.length > 100 ? '...' : ''))
                await processBuffer()
            }

            // After stream processing ends, update other states using the data from the last message
            if (lastMessageData) {
                // Check if this request is still valid before updating states
                if (currentRequestIdRef.current === requestId) {
                    setCurrentMessageID(lastMessageData.MessageID)
                    if (lastMessageData.InitialChatTitle) {
                        setChatTitle(lastMessageData.InitialChatTitle)
                    }
                }

                // Handle thread ID assignment based on message type (only if request is still valid)
                if (currentRequestIdRef.current === requestId) {
                    if (isScenario) {
                        setDocThreadID(lastMessageData.ThreadID)
                    } else {
                        if (docName === PDF_GUIDELINES.FANNIE_MAE) {
                            setDocThreadID(lastMessageData.ThreadID)
                        } else {
                            setNewfiThreadID(lastMessageData.ThreadID)
                        }
                    }
                }

                // Refresh chat history after new thread is created
                if (chatHistoryRef.current) {
                    chatHistoryRef.current.refreshChatList()
                }

                // Handle tracking for doc messages only
                if (!isScenario) {
                    TrackingDocMessage(message, lastMessageData.ThreadID)
                }

            }
        } catch (error) {
            console.error(
                `Send ${isScenario ? 'scenario' : 'doc'} message error:`,
                error
            )
            setIsBotAnswering(true)
            setIsProcessing(false)
            setProgressMessage('')
            
            // Provide more specific error messages based on error type
            let errorMessage = 'Sorry something went wrong, please try later'
            if (error.name === 'SyntaxError' && error.message.includes('JSON')) {
                errorMessage = 'There was an issue processing the response. Please try again.'
            } else if (error.message.includes('fetch')) {
                errorMessage = 'Network error. Please check your connection and try again.'
            } else if (error.message.includes('timeout')) {
                errorMessage = 'Request timed out. Please try again.'
            }
            
            setDocMessages((prevMessages) => {
                // Check if this request is still valid
                if (currentRequestIdRef.current !== requestId) {
                    return prevMessages; // Ignore updates from cancelled requests
                }
                return [
                    ...prevMessages,
                    {
                        text: errorMessage,
                        sender: 'bot',
                    },
                ]
            })
        } finally {
            setIsBotThinking(false)
            setIsReceivingAnswer(false) // Answer is now complete, enable send button
            setIsAnswerLoading(false) // Stop loading
            setIsProcessing(false)
            setProgressMessage('')
            isPdfLoadingRef.current = false
            
            // Clear saved state for this conversation since it's now complete
            if (docThreadID) {
                conversationStatesRef.current.delete(docThreadID)
            }
            
            if (!isScenario) {
                // Update usage count
                if(!sessionStorage.getItem("ZeitroA")){
                    const clientId = await getClientToken();
                    request(`/api/v1/limit/agency/${clientId}`,{method: 'PUT' });   
                }
                dispatch(subscriptions.updateGuidelineGPTUsage(gptUsage + 1))
            }
            if (IS_IFRAMES){
                let CURRENT_SCENARIO_AI_USE = getCurrentScenarioUsage();
                if (CURRENT_SCENARIO_AI_USE.DISABLED && profile?.AccountTier !== 'paid' && activeIframeSession) {
                    // Track usage limit reached
                    const totalUsage = CURRENT_SCENARIO_AI_USE.COUNT;
                    trackUsageLimitReached(totalUsage, profile, currentBillingStatus);
                    
                    setTriggerType('usage-limit-reached');
                    if (PATH_CUSTOMER_ID === 'successlending' && currentBillingStatus === 'inactive' && promoCodeValidity === 'valid') {
                        setApplyPromoCode(true);
                    }
                    setShowSelfPayUpgradeModal(true);
                }
            }
        }
    }

    const handleSendDocMessage = async (message, docName, clearInput) => {
        const canProceed = await checkQuestionLimit()
        if (!canProceed) return

        // Clear input only when message is actually being sent
        if (clearInput) clearInput()

        await questionStreaming(message, currentPdfType, docName, source)
    }

    // Function to abort current request and count usage for scenario AI
    const abortCurrentRequestAndCountUsage = useCallback(() => {
        // Only abort and count if there's an active request and it's scenario AI
        if (currentAbortControllerRef.current && currentRequestIdRef.current) {
            const isScenario = currentPdfType === CONTENT_TYPES.SCENARIO_GMCC || currentPdfType === CONTENT_TYPES.SCENARIO_DESK
            
            if (isScenario) {
                // Count usage immediately when aborting
                SCENARIO_AI_USE.onUsed()
                console.log("in abortCurrentRequestAndCountUsage, onUsed2", SCENARIO_AI_USE);
            }
            
            // Abort the current request
            currentAbortControllerRef.current.abort()
            currentAbortControllerRef.current = null
            currentRequestIdRef.current = null
            
            // Reset UI states
            setIsReceivingAnswer(false) // Answer is aborted, enable send button
            setIsAnswerLoading(false) // Stop loading
            setIsBotThinking(false)
            setIsBotAnswering(false)
            setIsProcessing(false)
            setProgressMessage('')
            isPdfLoadingRef.current = false
        }
    }, [currentPdfType, SCENARIO_AI_USE])

    const handleScenarioMessage = async (message, pdfType, guidelines, dynamicPdfInfo = null) => {
        if(signupGuide) return; // 如果被“引导注册” 就不要在发起询问了
        // Auto-display PDF immediately when user sends first question
        if (dynamicPdfInfo && dynamicPdfInfo.dynamicLoad && dynamicPdfInfo.pdfFileName) {
            // Display the first available PDF from selected lender immediately
            await jumpToPage(1, [], 0, dynamicPdfInfo) // Page 1, no coordinates, index 0
        }

        // If this is a new scenario message from the welcome screen, clear previous messages
        // This happens when guidelines are provided (new message from welcome screen)
        if (guidelines && guidelines.length > 0) {
            setDocMessages([])
        }

        // Set showDoc to true to show PDF viewer when sending a message
        setShowDoc(true)

        // Use guidelines if provided, otherwise use source from Redux state
        // For continuing chats, source will contain the document_ids from the loaded chat history
        const documentsToSend = guidelines || source

        await questionStreaming(
            message,
            pdfType || currentPdfType,
            null,
            documentsToSend
        )
    }

    const [docMessages, setDocMessages] = useState([
        { text: 'reset-greeting', sender: 'bot' },
    ])

    const handleSendMessage = async (newMessage, _docName, clearInput) => {
        const canProceed = await checkQuestionLimit()
        if (!canProceed) return

        // Clear input only when message is actually being sent
        if (clearInput) clearInput()

        setMessages([...messages, { text: newMessage, sender: 'user' }])
        setIsBotThinking(true)

        try {
            const token = sessionStorage.getItem('ZeitroA')
            const response = await fetch('/los/mortgagegpt/askwithoutdoc', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                    Cache: 'no-cache',
                },
                body: JSON.stringify({
                    Message: newMessage,
                    ThreadID: chatThreadID,
                }),
            })

            if (!response.ok) {
                loginExpired(response)
                throw new Error(`HTTP error! Status: ${response.status}`)
            }
                

            const data = await response.json()
            setMessages((prevMessages) => [
                ...prevMessages,
                { text: data.answer, sender: 'bot' },
            ])
            setChatThreadID(data.threadID)
        } catch (error) {
            console.error('Fetching error:', error)
            setMessages((prevMessages) => [
                ...prevMessages,
                {
                    text: 'Sorry something went wrong, please try later',
                    sender: 'bot',
                },
            ])
        } finally {
            setIsBotThinking(false)
        }
    }

    const handleNewChat = useCallback(() => {
        setDocMessages([{ text: 'reset-greeting', sender: 'bot' }])
        setChatTitle('')
        setDocThreadID('')
        setNewfiThreadID('')
        setChatThreadID('')
        setCurrentMessageID('')
    }, [])

    useEffect(() => {
        if (IS_IFRAMES) {
            dispatch({ type: 'PAGE_LOADING', data: false });
        }
    }, [IS_IFRAMES]);

    const onChangeMessageToSend = (val) => {
        setMessageToSend(val)
    }

    const loadChat = async (threadID, type) => {
        setLoadingChat(true)
        const token = IS_IFRAMES ? localStorage.getItem(getIframesToken()) : sessionStorage.getItem('ZeitroA')
        try {
            const response = await fetch('/los/mortgagegpt/loadchat', {
                method: 'POST',
                body: JSON.stringify({ ThreadID: threadID }),
                headers: {
                    Authorization: 'Bearer ' + token,
                    Cache: 'no-cache',
                },
            })

            if (response.status !== 200) {
                console.error(
                    'There was an error fetching the chat history: ',
                    response.status
                )
                setLoadingChat(false)
                return
            }

            const json = await response.json()
            const documents = json.documents || []
            const documentIds = json.document_ids || []
            
            // For ScenarioDesk, use document_ids from the thread for continuing the chat
            if (type === "ScenarioDesk") {
                if (documentIds.length > 0) {
                    // Use the document_ids from the thread for continuing the chat
                    console.log('Loading ScenarioDesk chat history with document_ids:', documentIds)
                    dispatch({ type: 'SCENARIO_SOURCE', data: documentIds })
                } else {
                    // Fallback to all available programs if no document_ids found
                    console.log('No document_ids found, using all available programs')
                    const allProgramIds = SCENARIO_PROGRAMS.map(program => program.id)
                    dispatch({ type: 'SCENARIO_SOURCE', data: allProgramIds })
                }
            } else {
                dispatch({ type: 'SCENARIO_SOURCE', data: documents })
            }
            setDocThreadID(json.thread.thread_id)
            if (json.thread.custom_title !== null) {
                setChatTitle(json.thread.custom_title)
            } else if (json.thread.initial_title !== null) {
                setChatTitle(json.thread.initial_title)
            }

            const chatHistory = json.chat_history.map((msg) => {
                if (msg.role === 'user') {
                    return {
                        text: msg.content,
                        sender: 'user',
                    }
                }
                // 在 “NonQM” 提问， quote_locations字段可能为 [1]，手动转换为[]
                if(msg?.quote_locations?.length === 1 && msg.quote_locations[0] === 1){
                    msg.quote_locations = [];
                }
                // Format the answer from the bot
                return {
                    text: formulateAnswer(
                        msg.content,
                        msg.page_numbers,
                        msg.quote_locations,
                        false, // Historical messages are not generating
                    ),
                    sender: 'bot',
                    thinking: msg.thinking_content ? [msg.thinking_content] : undefined
                }
            })

            // Only set messages if we don't have saved state (to avoid overriding restored messages)
            if (!conversationStatesRef.current.has(threadID)) {
                setDocMessages(chatHistory)
            }

            // Handle dynamic PDF loading for ScenarioDesk
            if (type === CONTENT_TYPES.SCENARIO_DESK && documents.length > 0) {
                // Try to find the first PDF document from the documents array
                const firstPdfDoc = documents.find(doc => 
                    doc && typeof doc === 'string' && doc.includes('.pdf')
                )
                
                if (firstPdfDoc) {
                    console.log('Loading ScenarioDesk chat history with PDF:', firstPdfDoc)
                    // Use the jumpToPage function to load the dynamic PDF
                    await jumpToPage(1, [], 0, {
                        pdfFileName: firstPdfDoc,
                        dynamicLoad: true
                    })
                } else {
                    // If no PDF found in documents, try to extract from chat history
                    // Look for document references in bot messages
                    for (const msg of json.chat_history) {
                        if (msg.role === 'assistant' && msg.content) {
                            // Look for document references like [Document, p.N] or [p.N, M-P] or [p.N, p.M]
                            const docMatch = msg.content.match(/\[([^,\]]+),\s*p\.\d+\]/) || 
                                           msg.content.match(/\[p\.(\d+),\s*\d+(?:-\d+)?\]/) ||
                                           msg.content.match(/\[p\.(\d+),\s*p\.(\d+)\]/)
                            if (docMatch) {
                                let docName, pageNum
                                
                                if (docMatch[1] && docMatch[2] && !docMatch[1].includes('p.')) {
                                    // Format: [Document, p.N]
                                    docName = docMatch[1].trim()
                                    pageNum = docMatch[2]
                                } else if (docMatch[1] && docMatch[2] && docMatch[1].includes('p.')) {
                                    // Format: [p.N, p.M] - just jump to first page in current document
                                    pageNum = docMatch[1].replace('p.', '')
                                    docName = null
                                } else if (docMatch[1] && docMatch[2] === undefined) {
                                    // Format: [p.N, M-P] - just jump to page in current document
                                    pageNum = docMatch[1]
                                    docName = null
                                }
                                
                                console.log('Found document reference in chat history:', { docName, pageNum })
                                
                                if (docName) {
                                    // Load the PDF based on the document name
                                    await jumpToPage(1, [], 0, {
                                        pdfFileName: docName + '.pdf',
                                        dynamicLoad: true
                                    })
                                } else {
                                    // Just jump to the page in current document
                                    await jumpToPage(parseInt(pageNum), [], 0)
                                }
                                break
                            }
                        }
                    }
                }
            }
            return json
        } catch (err) {
            console.error('Fetch Error :-S', err)
        } finally {
            setLoadingChat(false)
            // Only set current request ID if we don't have saved state (to avoid overriding restored state)
            if (!conversationStatesRef.current.has(threadID)) {
                currentRequestIdRef.current = threadID
            }
        }
    }
    useEffect(() => {
        if (typeof threadID !== 'undefined') {
            setChatThreadID(threadID)
            loadChat(threadID).then((res) => {
                const type = res?.thread?.doc
                if(type){
                    getHistoryList(threadID, type)
                    sessionStorage.setItem(
                        "activeGPTmode",
                        // 会话历史记录的 “会话类型”
                        type === "ScenarioDesk" ? "scenario" : "guideline",
                    );
                }
            })
        }
    }, [])

    const getList = useCallback(
        (e) => {
            setChatList(e)
        },
        [setChatList]
    )

    const getHistoryList = useCallback(
        (threadId, type) => {
            // sessionStorage.setItem('gpt_type', type);
            // sessionStorage.setItem('gpt_thread', threadId);
            
            // // Handle clicking the same history item (threadId === docThreadID)
            // if (docThreadID && docThreadID === threadId) {
            //     // If clicking the same thread and there's an active conversation, preserve current state
            //     if (isReceivingAnswer || isProcessing || isBotThinking || isBotAnswering) {
            //         // Don't call loadChat to avoid overriding current messages and state
            //         dispatch({ type: 'SHOW_PDF', data: false })
            //         dispatch({ type: 'CHANGE_PDF', data: getPdfType(type) })
            //         return
            //     }
            //     // If no active conversation, proceed with normal loading
            // }
            
            // Save current conversation state before switching (if we have a different current thread)
            if (docThreadID && docThreadID !== threadId) {
                // Only save state if there's an active conversation (receiving answer or processing)
                if (isReceivingAnswer || isProcessing || isBotThinking || isBotAnswering) {
                    conversationStatesRef.current.set(docThreadID, {
                        isReceivingAnswer,
                        isBotThinking,
                        isBotAnswering,
                        isProcessing,
                        progressMessage,
                        currentMessageID,
                        currentMessageText,
                        docMessages: [...docMessages], // Create a copy
                        requestId: currentRequestIdRef.current
                    })
                } else {
                    // If no active conversation, remove any existing saved state
                    conversationStatesRef.current.delete(docThreadID)
                }
            }
            
            // Check if we have saved state for the target thread
            const savedState = conversationStatesRef.current.get(threadId)
            
            if (savedState) {
                // Restore saved state for ongoing conversation
                setIsReceivingAnswer(savedState.isReceivingAnswer)
                setIsAnswerLoading(savedState.isReceivingAnswer) // Restore loading state based on isReceivingAnswer
                setIsBotThinking(savedState.isBotThinking)
                setIsBotAnswering(savedState.isBotAnswering)
                setIsProcessing(savedState.isProcessing)
                setProgressMessage(savedState.progressMessage)
                setCurrentMessageID(savedState.currentMessageID)
                setCurrentMessageText(savedState.currentMessageText)
                setDocMessages(savedState.docMessages)
                currentRequestIdRef.current = savedState.requestId
            } else {
                // Reset states for new/completed conversation
                setIsReceivingAnswer(false)
                setIsAnswerLoading(false)
                setIsBotThinking(false)
                setIsBotAnswering(false)
                setIsProcessing(false)
                setProgressMessage('')
                setCurrentMessageID('')
                // isPdfLoading is computed, no need to set it directly
                setCurrentMessageText('')
                currentRequestIdRef.current = null
            }
            
            dispatch({ type: 'SHOW_PDF', data: false })
            dispatch({ type: 'CHANGE_PDF', data: getPdfType(type) })
            loadChat(threadId, type)
        },
        [dispatch, loadChat, docThreadID, isReceivingAnswer, isBotThinking, isBotAnswering, 
         isProcessing, progressMessage, currentMessageID, currentMessageText, docMessages]
    )

    // 如果没有任何内容，直接跳转至main页面
    useEffect(() => {
        // 首次加载页面 既不是发起提问、又没有threadID（历史记录），跳转至主页面
        if(IS_PATH_CONFIG_ENABLED && !isReceivingAnswer && !threadID){
            dispatch({ type: 'SHOW_PDF', data: true })
            dispatch({ type: 'CHANGE_PDF', data: undefined })
            handleNewChat();
        }
    },[threadID, IS_PATH_CONFIG_ENABLED]);

    // useEffect(() => {
    //     const docThread = sessionStorage.getItem('gpt_thread');
    //     if(!docThread) return;
    //     const type = sessionStorage.getItem('gpt_type');
    //     getHistoryList(docThread, type);
    // },[])

    const paywallModalShow = () => {
        setShowPaywallModal(true)
    }

    const paywallModalCancel = () => {
        setShowPaywallModal(false)
    }
    const handleContactClick = () => {
        window.open('mailto:support@zeitro.com', '_blank');
    }

    const handleIframeSigninClick = () => {
        setShowIframeLoginModal(true)
        setIsIframeSignup(false)
    }

    const handleIframeSignupClick = () => {
        setShowIframeLoginModal(true)
        setIsIframeSignup(true)
    }

    /**
     * @name onPreviewGuideline 预览查看 "guideline"
     * @description 用户希望 "Scenario AI"，可以直接点击查看pdf文件，所以这里进入对话页面，不需要立马进行提问
     */
    const onPreviewGuideline = useCallback((guideline) => {
        setMobileAIChat(false);
        setPreviewId(guideline.id);
        // Try S3 path first (only if it's a valid PDF path), otherwise fallback to local path
        const s3Url = convertS3PathToUrl(guideline.filePath, guideline.fileName);
        const pdfPath = s3Url || `/scenario_pdfs/${guideline.fileName}`;
        setDynamicPdfFile(pdfPath);
        dispatch({ type: 'SHOW_PDF', data: false })
        dispatch({ type: 'CHANGE_PDF', data: CONTENT_TYPES.SCENARIO_DESK });
    }, []);

    // type 为空就是关闭弹窗 
    async function onSetSignType(type){
        // Track gate signin click event for standalone page (fromLanding = true)
        // This is triggered when user clicks "Sign in" link in the "Create a free account to unlock full answer" gate
        if (fromLanding && type === 'SIGNIN' && signupGuide) {
            trackSaspGateSigninClick();
        }
        setSignType(type);
        return onSuccess();
    }

    // 用户输入 email 并点击 “Continue” 按钮
    function onContinue(params){
        // Track gate signup click event for standalone page (fromLanding = true)
        if (fromLanding) {
            trackSaspGateSignupClick();
        }
        setSignType('SIGNUP');
        setJoin(params);
    }

    async function onSuccess(){
        if(sessionStorage.getItem("ZeitroA")){
            // Clear customerId cache to ensure fresh data after login
            com.clearCustomerIdCache();
            // Refresh guideline list after successful login
            if (programs?.run) {
                programs.run();
            }
            getSubscriptionInfo();
            return getUserProfile();
        }
    }

    useEffect(() => { 
        showPdf && setPreviewId(undefined);
    }, [showPdf]);

    const contact = useContact();

    useThrottleEffect(
        () => {
            if (IS_LOGIN) return setSignupGuide(undefined);
            if (IS_GUIDELINE_GPT && docMessages?.length > 1 && !signupGuide) {
            const lastBot = docMessages.findLast((v) => v.sender === "bot");
            setSignupGuide(
                lastBot?.text?.props?.answer?.length > 300
                ? document.getElementById(`chat-${docMessages?.length - 1}`)
                    ?.offsetHeight
                : undefined,
            );
            }
        },
        [docMessages, IS_LOGIN],
        { wait: 1000 },
    );

    useEffect(()=>{
        showPdf && setSignupGuide(undefined);
    },[showPdf]);

    if (pageLoading) {
        return (
            <>  
                <Skeleton className="mt-3" active />
                <Skeleton className="mt-3" active />
                <Skeleton className="mt-3" active />
            </>
        )
    }

    if (showPdf) {
        return isMobile ? (
            <>
                <Sign join={join} openType={signType} onOpenTypeChange={onSetSignType} />

                {(IS_IFRAMES || IS_GUIDELINE_GPT) && (
                    <IframeNav
                        onAIChange={onAIChange}
                        chatTitle={chatTitle}
                        fromLanding={fromLanding}
                        onCloseMask={() => setPreviewId(undefined)}
                        onNewChat={handleNewChat}
                        setIsReceivingAnswer={setIsReceivingAnswer}
                        iframeConfig={iframeConfig}
                        activeIframeSession={IS_GUIDELINE_GPT ? profile?.LoID : activeIframeSession}
                        handleContactClick={handleContactClick}
                        handleIframeSigninClick={IS_GUIDELINE_GPT ? ()=>{
                            trackStandaloneSigninClick();
                            setSignType('SIGNIN');
                        } : handleIframeSigninClick}
                        handleIframeSignupClick={IS_GUIDELINE_GPT ? ()=>{
                            trackStandaloneSignupClick();
                            setSignType('SIGNUP');
                        } : handleIframeSignupClick}
                        profile={profile}
                        subscriptionInfo={subscriptionInfo}
                        ref={chatHistoryRef}
                        programs={programs}
                        getHistoryList={getHistoryList}
                        getList={getList}
                        showHistory={showHistory}
                        setShowHistory={setShowHistory}
                        threadID={docThreadID}
                        showPdf={showPdf}
                        titleEmitter={titleEmitter}
                        setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                        onCheckOut={handleCheckOut}
                        companyPayMode={companyPayMode}
                        currentBillingStatus={currentBillingStatus}
                        portalSessionUrl={portalSessionUrl}
                        promoCodeValidity={promoCodeValidity}
                        setApplyPromoCode={setApplyPromoCode}
                        setTriggerType={setTriggerType}
                        downgradedTime={downgradedTime}
                        isMobile={isMobile}
                        usage={getCurrentScenarioUsage().COUNT}
                    />
                )}
                <WelcomeGuideline
                    isPaid={IS_PAID}
                    getList={getList}
                    showPdf={showPdf}
                    onAIChange={onAIChange}
                    setSignType={setSignType}
                    downgradedTime={downgradedTime}
                    onCheckOut={handleCheckOut}
                    titleEmitter={titleEmitter}
                    docThreadID={docThreadID}
                    portalSessionUrl={portalSessionUrl}
                    subscriptionInfo={subscriptionInfo}
                    chatHistoryRef={chatHistoryRef}
                    getHistoryList={getHistoryList}
                    iframeConfig={iframeConfig}
                    programs={programs}
                    contact={contact}
                    anomaly={anomaly}
                    onPreviewGuideline={onPreviewGuideline}
                    isReceivingAnswer={isReceivingAnswer}
                    showHistory={showHistory}
                    setShowHistory={setShowHistory}
                    isMobile={isMobile}
                    fromLanding={fromLanding}
                    onSendMessage={handleScenarioMessage}
                    activeIframeSession={activeIframeSession}
                    setShowIframeLoginModal={setShowIframeLoginModal}
                    companyPayMode={companyPayMode}
                    setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                    profile={profile}
                    setTriggerType={setTriggerType}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    setApplyPromoCode={setApplyPromoCode}
                />
                {openHistory && (
                    <div
                        className="history-overlay"
                        onClick={() => setShowHistory(false)}
                    />
                )}
                <div className={`history-panel ${openHistory ? 'open' : ''}`}>
                    <ChatHistory
                        ref={chatHistoryRef}
                        programs={programs}
                        getHistoryList={getHistoryList}
                        getList={getList}
                        showHistory={showHistory}
                        setShowHistory={setShowHistory}
                        isMobile={isMobile}
                        titleEmitter={titleEmitter}
                    />
                </div>
                <IframeLoginModal
                    iframeConfig={iframeConfig}
                    isOpen={showIframeLoginModal}
                    onClose={() => setShowIframeLoginModal(false)}
                    isSignUp={isIframeSignup}
                    setIsSignUp={setIsIframeSignup}    
                    companyName={companyName}
                    setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                    companyPayMode={companyPayMode}
                    setTriggerType={setTriggerType}
                    SCENARIO_AI_USE={SCENARIO_AI_USE}
                    setApplyPromoCode={setApplyPromoCode}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    profile={profile}
                    usage={getCurrentScenarioUsage().COUNT}
                />
                {companyPayMode === 'self_pay' && <SelfPayUpgradeModal
                    isOpen={showSelfPayUpgradeModal}
                    onCancel={handleCloseUpgradeModal}
                    triggerType={triggerType}
                    onCheckOut={handleCheckOut}
                    selfPayPriceAmount={selfPayPriceAmount}
                    portalSessionUrl={portalSessionUrl}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    profile={profile}
                    usage={getCurrentScenarioUsage().COUNT}
                />}
            </>
        ) : (
            <>
                <Sign join={join} openType={signType} onOpenTypeChange={onSetSignType} />
                {(IS_IFRAMES || IS_GUIDELINE_GPT) && (
                    <IframeNav
                        onAIChange={onAIChange}
                        chatTitle={chatTitle}
                        fromLanding={fromLanding}
                        onCloseMask={() => setPreviewId(undefined)}
                        onNewChat={handleNewChat}
                        setIsReceivingAnswer={setIsReceivingAnswer}
                        iframeConfig={iframeConfig}
                        activeIframeSession={IS_GUIDELINE_GPT ? profile?.LoID : activeIframeSession}
                        handleContactClick={handleContactClick}
                        handleIframeSigninClick={IS_GUIDELINE_GPT ? ()=>{
                            trackStandaloneSigninClick();
                            setSignType('SIGNIN');
                        } : handleIframeSigninClick}
                        handleIframeSignupClick={IS_GUIDELINE_GPT ? ()=>{
                            trackStandaloneSignupClick();
                            setSignType('SIGNUP');
                        } : handleIframeSignupClick}
                        profile={profile}
                        subscriptionInfo={subscriptionInfo}
                        ref={chatHistoryRef}
                        programs={programs}
                        getHistoryList={getHistoryList}
                        getList={getList}
                        showHistory={showHistory}
                        setShowHistory={setShowHistory}
                        threadID={docThreadID}
                        showPdf={showPdf}
                        titleEmitter={titleEmitter}
                        setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                        onCheckOut={handleCheckOut}
                        companyPayMode={companyPayMode}
                        currentBillingStatus={currentBillingStatus}
                        portalSessionUrl={portalSessionUrl}
                        promoCodeValidity={promoCodeValidity}
                        setApplyPromoCode={setApplyPromoCode}
                        setTriggerType={setTriggerType}
                        downgradedTime={downgradedTime}
                        isMobile={isMobile}
                        usage={getCurrentScenarioUsage().COUNT}
                    />
                )}
                <Row>
                    <Col md={showHistory ? 10 : 12} className="px-0">
                        <WelcomeGuideline
                            isPaid={IS_PAID}
                            getList={getList}
                            showPdf={showPdf}
                            onAIChange={onAIChange}
                            setSignType={setSignType}
                            downgradedTime={downgradedTime}
                            onCheckOut={handleCheckOut}
                            portalSessionUrl={portalSessionUrl}
                            subscriptionInfo={subscriptionInfo}
                            docThreadID={docThreadID}
                            titleEmitter={titleEmitter}
                            chatHistoryRef={chatHistoryRef}
                            getHistoryList={getHistoryList}
                            iframeConfig={iframeConfig}
                            programs={programs}
                            contact={contact}
                            anomaly={anomaly}
                            onPreviewGuideline={onPreviewGuideline}
                            isReceivingAnswer={isReceivingAnswer}
                            showHistory={showHistory}
                            setShowHistory={setShowHistory}
                            isMobile={isMobile}
                            fromLanding={fromLanding}
                            onSendMessage={handleScenarioMessage}
                            activeIframeSession={activeIframeSession}
                            setShowIframeLoginModal={setShowIframeLoginModal}
                            companyPayMode={companyPayMode}
                            setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                            profile={profile}
                            setTriggerType={setTriggerType}
                            currentBillingStatus={currentBillingStatus}
                            promoCodeValidity={promoCodeValidity}
                            setApplyPromoCode={setApplyPromoCode}
                        />
                    </Col>
                    {openHistory && !IS_IFRAMES && !anomaly?.DATABASE_ERROR && (
                        <Col md={2} className="px-0">
                            <div
                                className="leftBorder"
                                style={{
                                    background: '#F6F6F6',
                                    height: '100vh',
                                    overflow: 'auto',
                                }}
                            >
                                <ChatHistory
                                    ref={chatHistoryRef}
                                    programs={programs}
                                    isMobile={isMobile}
                                    getHistoryList={getHistoryList}
                                    getList={getList}
                                    showHistory={showHistory}
                                    setShowHistory={setShowHistory}
                                    threadID={docThreadID}
                                    showPdf={showPdf}
                                    titleEmitter={titleEmitter}
                                />
                            </div>
                        </Col>
                    )}
                </Row>
                <IframeLoginModal
                    iframeConfig={iframeConfig}
                    isOpen={showIframeLoginModal}
                    onClose={() => setShowIframeLoginModal(false)}
                    isSignUp={isIframeSignup}
                    setIsSignUp={setIsIframeSignup}    
                    companyName={companyName}
                    setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                    companyPayMode={companyPayMode}
                    setTriggerType={setTriggerType}
                    SCENARIO_AI_USE={SCENARIO_AI_USE}
                    setApplyPromoCode={setApplyPromoCode}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    profile={profile}
                    usage={getCurrentScenarioUsage().COUNT}
                />
                {companyPayMode === 'self_pay' && <SelfPayUpgradeModal
                    isOpen={showSelfPayUpgradeModal}
                    onCancel={handleCloseUpgradeModal}
                    triggerType={triggerType}
                    onCheckOut={handleCheckOut}
                    selfPayPriceAmount={selfPayPriceAmount}
                    portalSessionUrl={portalSessionUrl}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    profile={profile}
                    usage={getCurrentScenarioUsage().COUNT}
                />}
            </>
        )
    }

    if (showDoc) {
        return (
            <>
                <Sign join={join} openType={signType} onOpenTypeChange={onSetSignType} />
                {(IS_IFRAMES || IS_GUIDELINE_GPT) && (
                    isMobile && showChat ? 
                        <></> 
                    : 
                        <IframeNav
                            onAIChange={onAIChange}
                            chatTitle={chatTitle}
                            fromLanding={fromLanding}
                            onNewChat={handleNewChat}
                            onCloseMask={() => setPreviewId(undefined)}
                            setIsReceivingAnswer={setIsReceivingAnswer}
                            iframeConfig={iframeConfig}
                            activeIframeSession={IS_GUIDELINE_GPT ? profile?.LoID : activeIframeSession}
                            handleContactClick={handleContactClick}
                            handleIframeSigninClick={IS_GUIDELINE_GPT ? ()=>{
                                trackStandaloneSigninClick();
                                setSignType('SIGNIN');
                            } : handleIframeSigninClick}
                            handleIframeSignupClick={IS_GUIDELINE_GPT ? ()=>{
                                trackStandaloneSignupClick();
                                setSignType('SIGNUP');
                            } : handleIframeSignupClick}
                            profile={profile}
                            subscriptionInfo={subscriptionInfo}
                            programs={programs}
                            getHistoryList={getHistoryList}
                            getList={getList}
                            showHistory={showHistory}
                            setShowHistory={setShowHistory}
                            threadID={docThreadID}
                            showPdf={showPdf}
                            titleEmitter={titleEmitter}
                            setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                            onCheckOut={handleCheckOut}
                            companyPayMode={companyPayMode}
                            currentBillingStatus={currentBillingStatus}
                            portalSessionUrl={portalSessionUrl}
                            promoCodeValidity={promoCodeValidity}
                            setApplyPromoCode={setApplyPromoCode}
                            setTriggerType={setTriggerType}
                            downgradedTime={downgradedTime}
                            isMobile={isMobile}
                            usage={getCurrentScenarioUsage().COUNT}
                        />
                )}
                <div className={`chat ${(IS_IFRAMES || IS_GUIDELINE_GPT) ? 'iframe-chat-adjuster' : ''}`}>
                    <ContinueJourney
                        isOpen={showContinueJourney}
                        anonymousId={anonymousId}
                        onClose={() => setShowContinueJourney(false)}
                        onSuccess={() => setJourneySubmitted(true)}
                    />
                    <PaywallModal
                        open={showPaywallModal}
                        onCancel={() => paywallModalCancel()}
                    />
                    <LimitReachedModal
                        isOpen={showLimitModal}
                        onClose={() => setShowLimitModal(false)}
                    />
                    {isMobile ? (
                        <>
                            {showChat && (
                                <div className="chat-app">
                                    {IS_MORTGAGE_GPT() ? <MessageHeader
                                            chatTitle={chatTitle}
                                            threadID={docThreadID}
                                            fromLanding={fromLanding}
                                            setSignType={setSignType}
                                            setShowHistory={setShowHistory}
                                            showHistory={showHistory}
                                            onNewChat={handleNewChat}
                                            isMobile={isMobile}
                                            setMobileAIChat={setMobileAIChat}
                                            setIsReceivingAnswer={setIsReceivingAnswer}
                                            onAbortAndCountUsage={abortCurrentRequestAndCountUsage}
                                            isFreddieMacStandalone={isFreddieMacStandalone}
                                            isFannieMaeStandalone={isFannieMaeStandalone}
                                            hideBackButton={hideBackButton}
                                        /> :  
                                        <IframeNav
                                            onAIChange={onAIChange}
                                            chatTitle={chatTitle}
                                            fromLanding={fromLanding}
                                            onCloseMask={() => setPreviewId(undefined)}
                                            onNewChat={handleNewChat}
                                            setIsReceivingAnswer={setIsReceivingAnswer}
                                            iframeConfig={iframeConfig}
                                            activeIframeSession={IS_GUIDELINE_GPT ? profile?.LoID : activeIframeSession}
                                            handleContactClick={handleContactClick}
                                            handleIframeSigninClick={IS_GUIDELINE_GPT ? ()=>setSignType('SIGNIN') : handleIframeSigninClick}
                                            handleIframeSignupClick={IS_GUIDELINE_GPT ? ()=>setSignType('SIGNUP') : handleIframeSignupClick}
                                            profile={profile}
                                            programs={programs}
                                            getHistoryList={getHistoryList}
                                            getList={getList}
                                            showHistory={showHistory}
                                            setShowHistory={setShowHistory}
                                            threadID={docThreadID}
                                            showPdf={showPdf}
                                            titleEmitter={titleEmitter}
                                            setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                                            onCheckOut={handleCheckOut}
                                            companyPayMode={companyPayMode}
                                            currentBillingStatus={currentBillingStatus}
                                            portalSessionUrl={portalSessionUrl}
                                            promoCodeValidity={promoCodeValidity}
                                            setApplyPromoCode={setApplyPromoCode}
                                            setTriggerType={setTriggerType}
                                            downgradedTime={downgradedTime}
                                            isMobile={isMobile}
                                            usage={getCurrentScenarioUsage().COUNT}
                                    />}
                                    
                                    {mobileAIChat ? (
                                        <>
                                            <MessageList
                                                contact={contact}
                                                onSuccess={onSuccess}
                                                onContinue={onContinue} 
                                                onToSignUp={onSetSignType}
                                                signupGuide={signupGuide}
                                                programs={programs}
                                                previewId={previewId}
                                                isLandingWelcome={isLandingWelcome}
                                                loadingChat={loadingChat}
                                                messages={docMessages}
                                                threadID={docThreadID}
                                                isBotThinking={isBotThinking}
                                                isBotAnswering={isBotAnswering}
                                                isReceivingAnswer={
                                                    isReceivingAnswer
                                                }
                                                isProcessing={isProcessing}
                                                progressMessage={progressMessage}
                                                currentMessageID={currentMessageID}
                                                currentMessageText={
                                                    currentMessageText
                                                }
                                                isMobile={isMobile}
                                                setMobileAIChat={setMobileAIChat}
                                                pdCFontent={pdCFontent}
                                                usage={gptUsage}
                                                onSendMessage={handleSendDocMessage}
                                                onScenarioSearch={
                                                    handleScenarioMessage
                                                }
                                                isFannieMaeStandalone={isFannieMaeStandalone}
                                                isFreddieMacStandalone={isFreddieMacStandalone}
                                            />
                                            <div className="chat-input-container">
                                                <ChatInput
                                                    anomaly={anomaly}
                                                    isPaid={IS_PAID}
                                                    signupGuide={signupGuide}
                                                    programs={programs}
                                                    setSignType={setSignType}
                                                    onSendMessage={
                                                        handleSendDocMessage
                                                    }
                                                    onScenarioSearch={
                                                        handleScenarioMessage
                                                    }
                                                    onShowPayWall={paywallModalShow}
                                                    isBotThinking={isBotThinking}
                                                    isReceivingAnswer={
                                                        isReceivingAnswer
                                                    }
                                                    docName={currentDocName}
                                                    fromLanding={fromLanding}
                                                    usage={gptUsage}
                                                    journeySubmitted={
                                                        journeySubmitted
                                                    }
                                                    isLandingWelcome={
                                                        isLandingWelcome
                                                    }
                                                    threadID={docThreadID}
                                                    isMobile={isMobile}
                                                    isFreddieMacStandalone={isFreddieMacStandalone}
                                                    isFannieMaeStandalone={isFannieMaeStandalone}
                                                    setShowIframeLoginModal={setShowIframeLoginModal}
                                                    activeIframeSession={activeIframeSession}
                                                    profile={profile}
                                                    companyPayMode={companyPayMode}
                                                    setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                                                    setTriggerType={setTriggerType}
                                                    currentBillingStatus={currentBillingStatus}
                                                    promoCodeValidity={promoCodeValidity}
                                                    setApplyPromoCode={setApplyPromoCode}
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <PDFViewer
                                            ref={PDFRef}
                                            anomaly={anomaly}
                                            programs={programs}
                                            previewId={previewId}
                                            file={dynamicPdfFile || PDF_CONTENT[currentPdfType]}
                                            jumpEmitter={jumpEmitter}
                                            mountEmitter={mountEmitter}
                                            isMobile={isMobile}
                                            setMobileAIChat={setMobileAIChat}
                                            source={source}
                                            isScenario={currentPdfType === CONTENT_TYPES.SCENARIO_DESK || currentPdfType === CONTENT_TYPES.SCENARIO_GMCC}
                                            isPdfLoading={isPdfLoading}
                                            onPdfLoadingChange={(loading) => {
                                                setIsPdfLoadingFromPdf(loading)
                                                isPdfLoadingFromPdfRef.current = loading
                                            }}
                                        />
                                    )}
                                </div>
                            )}
                            {openHistory && (
                                <div
                                    className="history-overlay"
                                    onClick={() => setShowHistory(false)}
                                />
                            )}
                            <div
                                className={`history-panel ${
                                    openHistory ? 'open' : ''
                                }`}
                            >
                                <ChatHistory
                                    onCloseMask={() => setPreviewId(undefined)}
                                    ref={chatHistoryRef}
                                    programs={programs}
                                    getHistoryList={getHistoryList}
                                    getList={getList}
                                    showHistory={showHistory}
                                    setShowHistory={setShowHistory}
                                    threadID={docThreadID}
                                    isMobile={isMobile}
                                    titleEmitter={titleEmitter}
                                />
                            </div>
                        </>
                    ) : (
                        <div style={{ width: '100%' }}>
                            <Row className="px-0">
                                <Col md={showHistory ? 5 : 6} className="px-0">
                                    <PDFViewer
                                        ref={PDFRef}
                                        anomaly={anomaly}
                                        programs={programs}
                                        previewId={previewId}
                                        file={dynamicPdfFile || PDF_CONTENT[currentPdfType]}
                                        jumpEmitter={jumpEmitter}
                                        mountEmitter={mountEmitter}
                                        source={source}
                                        isScenario={currentPdfType === CONTENT_TYPES.SCENARIO_DESK || currentPdfType === CONTENT_TYPES.SCENARIO_GMCC}
                                        isPdfLoading={isPdfLoading}
                                        onPdfLoadingChange={(loading) => {
                                            setIsPdfLoadingFromPdf(loading)
                                            isPdfLoadingFromPdfRef.current = loading
                                        }}
                                    />
                                </Col>
                                <Col md={showHistory ? 5 : 6} className="px-0">
                                    {showChat && (
                                        <div className={`chat-app ${(IS_IFRAMES || IS_GUIDELINE_GPT) ? 'iframe-chat-app-adjuster' : ''}`}>
                                            <MessageHeader
                                                chatTitle={chatTitle}
                                                threadID={docThreadID}
                                                fromLanding={fromLanding}
                                                setSignType={setSignType}
                                                setShowHistory={setShowHistory}
                                                showHistory={showHistory}
                                                onNewChat={handleNewChat}
                                                setIsReceivingAnswer={setIsReceivingAnswer}
                                                onAbortAndCountUsage={abortCurrentRequestAndCountUsage}
                                                isFreddieMacStandalone={isFreddieMacStandalone}
                                                isFannieMaeStandalone={isFannieMaeStandalone}
                                                hideBackButton={hideBackButton}
                                            />
                                            <MessageList
                                                contact={contact}
                                                programs={programs}
                                                onSuccess={onSuccess}
                                                onContinue={onContinue} 
                                                onToSignUp={onSetSignType}
                                                previewId={previewId}
                                                signupGuide={signupGuide}
                                                isLandingWelcome={isLandingWelcome}
                                                loadingChat={loadingChat}
                                                messages={docMessages}
                                                threadID={docThreadID}
                                                isBotThinking={isBotThinking}
                                                isBotAnswering={isBotAnswering}
                                                isReceivingAnswer={
                                                    isReceivingAnswer
                                                }
                                                isProcessing={isProcessing}
                                                progressMessage={progressMessage}
                                                currentMessageID={currentMessageID}
                                                currentMessageText={
                                                    currentMessageText
                                                }
                                                pdCFontent={pdCFontent}
                                                usage={gptUsage}
                                                onSendMessage={handleSendDocMessage}
                                                onScenarioSearch={
                                                    handleScenarioMessage
                                                }
                                                isFannieMaeStandalone={isFannieMaeStandalone}
                                                isFreddieMacStandalone={isFreddieMacStandalone}
                                            />
                                            <ChatInput
                                                anomaly={anomaly}
                                                isPaid={IS_PAID}
                                                programs={programs}
                                                setSignType={setSignType}
                                                signupGuide={signupGuide}
                                                onSendMessage={handleSendDocMessage}
                                                onScenarioSearch={
                                                    handleScenarioMessage
                                                }
                                                onShowPayWall={paywallModalShow}
                                                isBotThinking={isBotThinking}
                                                isReceivingAnswer={
                                                    isReceivingAnswer
                                                }
                                                docName={currentDocName}
                                                fromLanding={fromLanding}
                                                usage={gptUsage}
                                                journeySubmitted={journeySubmitted}
                                                isLandingWelcome={isLandingWelcome}
                                                threadID={docThreadID}
                                                isMobile={isMobile}
                                                isFreddieMacStandalone={isFreddieMacStandalone}
                                                isFannieMaeStandalone={isFannieMaeStandalone}
                                                setShowIframeLoginModal={setShowIframeLoginModal}
                                                activeIframeSession={activeIframeSession}
                                                profile={profile}
                                                companyPayMode={companyPayMode}
                                                setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                                                setTriggerType={setTriggerType}
                                                currentBillingStatus={currentBillingStatus}
                                                promoCodeValidity={promoCodeValidity}
                                                setApplyPromoCode={setApplyPromoCode}
                                            />
                                        </div>
                                    )}
                                </Col>
                                {openHistory && !IS_IFRAMES && (
                                    <Col md={2} className="px-0">
                                        <ChatHistory
                                            onCloseMask={() => setPreviewId(undefined)}
                                            ref={chatHistoryRef}
                                            programs={programs}
                                            isMobile={isMobile}
                                            getHistoryList={getHistoryList}
                                            getList={getList}
                                            showHistory={showHistory}
                                            setShowHistory={setShowHistory}
                                            threadID={docThreadID}
                                            showPdf={showPdf}
                                            titleEmitter={titleEmitter}
                                        />
                                    </Col>
                                )}
                            </Row>
                        </div>
                    )}
                </div>
                <IframeLoginModal
                    iframeConfig={iframeConfig}
                    isOpen={showIframeLoginModal}
                    onClose={() => setShowIframeLoginModal(false)}
                    isSignUp={isIframeSignup}
                    setIsSignUp={setIsIframeSignup}    
                    companyName={companyName}
                    setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                    companyPayMode={companyPayMode}
                    setTriggerType={setTriggerType}
                    SCENARIO_AI_USE={SCENARIO_AI_USE}
                    setApplyPromoCode={setApplyPromoCode}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    profile={profile}
                    usage={getCurrentScenarioUsage().COUNT}
                />
                {companyPayMode === 'self_pay' && <SelfPayUpgradeModal
                    isOpen={showSelfPayUpgradeModal}
                    onCancel={handleCloseUpgradeModal}
                    triggerType={triggerType}
                    onCheckOut={handleCheckOut}
                    selfPayPriceAmount={selfPayPriceAmount}
                    portalSessionUrl={portalSessionUrl}
                    currentBillingStatus={currentBillingStatus}
                    promoCodeValidity={promoCodeValidity}
                    profile={profile}
                    usage={getCurrentScenarioUsage().COUNT}
                />}
            </>
        )
    }

    return (
        <>
            <Sign join={join} openType={signType} onOpenTypeChange={onSetSignType} />
            {(IS_IFRAMES || IS_GUIDELINE_GPT) && (
                <IframeNav
                    onAIChange={onAIChange}
                    chatTitle={chatTitle}
                    fromLanding={fromLanding}
                    onNewChat={handleNewChat}
                    onCloseMask={() => setPreviewId(undefined)}
                    setIsReceivingAnswer={setIsReceivingAnswer}
                    iframeConfig={iframeConfig}
                    activeIframeSession={IS_GUIDELINE_GPT ? profile?.LoID : activeIframeSession}
                    handleContactClick={handleContactClick}
                    handleIframeSigninClick={IS_GUIDELINE_GPT ? ()=>setSignType('SIGNIN') : handleIframeSigninClick}
                    handleIframeSignupClick={IS_GUIDELINE_GPT ? ()=>setSignType('SIGNUP') : handleIframeSignupClick}
                    profile={profile}
                    programs={programs}
                    getHistoryList={getHistoryList}
                    getList={getList}
                    showHistory={showHistory}
                    setShowHistory={setShowHistory}
                    threadID={docThreadID}
                    showPdf={showPdf}
                    titleEmitter={titleEmitter}
                    setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                    onCheckOut={handleCheckOut}
                    companyPayMode={companyPayMode}
                    currentBillingStatus={currentBillingStatus}
                    portalSessionUrl={portalSessionUrl}
                    promoCodeValidity={promoCodeValidity}
                    setApplyPromoCode={setApplyPromoCode}
                    setTriggerType={setTriggerType}
                    downgradedTime={downgradedTime}
                    isMobile={isMobile}
                    usage={getCurrentScenarioUsage().COUNT}
                />
            )}
            <div className={`chat ${(IS_IFRAMES || IS_GUIDELINE_GPT) ? 'iframe-chat-adjuster' : ''}`}>
                <ContinueJourney
                    isOpen={showContinueJourney}
                    anonymousId={anonymousId}
                    onClose={() => setShowContinueJourney(false)}
                    onSuccess={() => setJourneySubmitted(true)}
                />
                <PaywallModal
                    open={showPaywallModal}
                    onCancel={() => paywallModalCancel()}
                />
                <LimitReachedModal
                    isOpen={showLimitModal}
                    onClose={() => setShowLimitModal(false)}
                />
                <div style={{ width: '100%' }}>
                    <div className="d-flex justify-content-center">
                        <ChatApp className="width70">
                            <MessageList
                                contact={contact}
                                programs={programs}
                                previewId={previewId}
                                onSuccess={onSuccess}
                                onContinue={onContinue} 
                                onToSignUp={onSetSignType}
                                signupGuide={signupGuide}
                                isLandingWelcome={isLandingWelcome}
                                messages={messages}
                                threadID={threadID}
                                isBotThinking={isBotThinking}
                                isBotAnswering={isBotAnswering}
                                isReceivingAnswer={isReceivingAnswer}
                                isProcessing={isProcessing}
                                progressMessage={progressMessage}
                                currentMessageID={currentMessageID}
                                currentMessageText={currentMessageText}
                                isMobile={isMobile}
                                pdCFontent={pdCFontent}
                                usage={gptUsage}
                                onSendMessage={handleSendMessage}
                                isFannieMaeStandalone={isFannieMaeStandalone}
                                isFreddieMacStandalone={isFreddieMacStandalone}
                            />
                            <ChatInput
                                anomaly={anomaly}
                                isPaid={IS_PAID}
                                programs={programs}
                                setSignType={setSignType}
                                signupGuide={signupGuide}
                                onSendMessage={handleSendMessage}
                                onShowPayWall={paywallModalShow}
                                style={{ marginBottom: 10 }}
                                isBotThinking={isBotThinking}
                                isReceivingAnswer={isReceivingAnswer}
                                docName={currentDocName}
                                fromLanding={fromLanding}
                                usage={gptUsage}
                                journeySubmitted={journeySubmitted}
                                isLandingWelcome={isLandingWelcome}
                                threadID={threadID}
                                isMobile={isMobile}
                                setShowIframeLoginModal={setShowIframeLoginModal}
                                activeIframeSession={activeIframeSession}
                                profile={profile}
                                companyPayMode={companyPayMode}
                                setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                                setTriggerType={setTriggerType}
                                currentBillingStatus={currentBillingStatus}
                                promoCodeValidity={promoCodeValidity}
                                setApplyPromoCode={setApplyPromoCode}
                            />
                        </ChatApp>
                    </div>
                </div>
            </div>
            <IframeLoginModal
                iframeConfig={iframeConfig}
                isOpen={showIframeLoginModal}
                onClose={() => setShowIframeLoginModal(false)}
                isSignUp={isIframeSignup}
                setIsSignUp={setIsIframeSignup}
                companyName={companyName}
                setShowSelfPayUpgradeModal={setShowSelfPayUpgradeModal}
                companyPayMode={companyPayMode}
                setTriggerType={setTriggerType}
                SCENARIO_AI_USE={SCENARIO_AI_USE}
                setApplyPromoCode={setApplyPromoCode}
                currentBillingStatus={currentBillingStatus}
                promoCodeValidity={promoCodeValidity}
                profile={profile}
                usage={getCurrentScenarioUsage().COUNT}
            />
            {companyPayMode === 'self_pay' && <SelfPayUpgradeModal
                isOpen={showSelfPayUpgradeModal}
                onCancel={handleCloseUpgradeModal}
                triggerType={triggerType}
                onCheckOut={handleCheckOut}
                selfPayPriceAmount={selfPayPriceAmount}
                portalSessionUrl={portalSessionUrl}
                currentBillingStatus={currentBillingStatus}
                promoCodeValidity={promoCodeValidity}
                profile={profile}
                usage={getCurrentScenarioUsage().COUNT}
            />}
        </>
    )
}

function ChatApp({ children, className }) {
    return <div className={`chat-app ${className}`}>{children}</div>
}

export default withRouter(Chat)
